export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.rightContent.org.unknown': 'Unknown Organization',
  'component.rightContent.menu.center': 'Profile',
  'component.rightContent.menu.settings': 'Settings',
  'component.rightContent.menu.currentOrg': 'Current Organization: {name}',
  'component.rightContent.menu.switchOrg': 'Switch Organization',
  'component.rightContent.menu.systemManagement': 'System Management',
  'component.rightContent.menu.logout': 'Log Out',
  'component.rightContent.theme.light': 'Switch to light theme',
  'component.rightContent.theme.dark': 'Switch to dark theme',
  'component.switchOrganization.title': 'Switch Organization',
  'component.switchOrganization.empty': 'No organizations available',
  'component.switchOrganization.action.switch': 'Switch',
  'component.switchOrganization.message.fetchFailed':
    'Failed to fetch organizations',
  'component.switchOrganization.message.success':
    'Organization switched successfully',
  'component.switchOrganization.message.failed':
    'Failed to switch organization',
  'auto.pages.pages.System.Menu.1': '工作台',
  'auto.pages.pages.System.Menu.2': '系统管理',
  'auto.pages.pages.System.Role.1': '管理员',
  'auto.pages.pages.System.Role.2': '系统管理员',
  'auto.pages.pages.System.Role.3': '普通用户',
  'auto.pages.pages.System.Role.4': '普通用户',
  'auto.pages.pages.System.User.1': '管理员',
  'auto.pages.pages.System.User.2': '管理员',
  'auto.pages.pages.System.User.3': '启用',
  'auto.pages.pages.System.User.4': '用户1',
  'auto.pages.pages.System.User.5': '普通用户',
  'auto.pages.pages.System.User.6': '启用',
  'auto.pages.pages.System.User.7': '管理员',
  'auto.pages.pages.System.User.8': '普通用户',
  'auto.pages.pages.System.User.9': '管理员',
  'auto.pages.pages.System.User.10': '普通用户',
  'auto.pages.pages.System.User.11': '启用',
  'auto.pages.pages.System.User.12': '禁用',
  'auto.pages.pages.System.User.13': '启用',
  'auto.pages.pages.System.User.14': '禁用',
  'auto.pages.pages.System.User.15': '启用',
  'auto.pages.pages.System.User.16': '管理员',
  'auto.pages.pages.System.User.17': '普通用户',
  'auto.pages.pages.System.User.18': '启用',
  'auto.pages.pages.System.User.19': '禁用',
  'auto.pages.pages.api-management.quick-debug.index.1': '接口快速调试',
  'auto.pages.pages.api-management.quick-debug.index.2':
    '快速验证接口请求与响应',
  'auto.pages.pages.api-management.quick-debug.index.3':
    '可在此配置请求参数、Header 与鉴权信息，快速调试接口。',
  'auto.pages.pages.api-management.quick-debug.index.4': '调试面板',
  'auto.pages.pages.api-management.quick-debug.index.5':
    '后续可接入接口选择、请求体编辑、响应结果查看与历史记录。',
  'auto.pages.pages.api-management.quick-debug.index.6':
    '接口快速调试功能建设中',
  'auto.component.pages.application.components.CreateAppModal.1': '创建应用',
  'auto.component.pages.application.components.CreateAppModal.2': '确定',
  'auto.component.pages.application.components.CreateAppModal.3': '取消',
  'auto.component.pages.application.components.CreateAppModal.4': '应用类型',
  'auto.component.pages.application.components.CreateAppModal.5': '应用名称',
  'auto.component.pages.application.components.CreateAppModal.6':
    '请输入应用名称',
  'auto.component.pages.application.components.CreateAppModal.7':
    '例如：我的应用',
  'auto.component.pages.application.components.CreateAppModal.8': '应用标识符',
  'auto.component.pages.application.components.CreateAppModal.9':
    '请输入应用标识符',
  'auto.component.pages.application.components.CreateAppModal.10':
    '例如：MyApp',
  'auto.component.pages.application.components.CreateAppModal.11':
    '组件框架（可选）',
  'auto.component.pages.application.components.CreateAppModal.12':
    '选择组件框架',
  'auto.component.pages.application.components.CreateAppModal.13':
    '应用描述（可选）',
  'auto.component.pages.application.components.CreateAppModal.14':
    '请输入应用描述',
  'auto.component.pages.application.components.CreateAppModal.15': '选择模板',
  'auto.component.pages.application.components.CreateAppModal.16':
    '暂无可用模板',
  'auto.component.pages.application.components.CreateAppModal.17':
    '请从左侧选择应用类型',
  'auto.pages.pages.application.constants.1': 'React Web应用',
  'auto.pages.pages.application.constants.2': '使用React框架开发的Web应用程序',
  'auto.pages.pages.application.constants.3': 'React管理后台模板',
  'auto.pages.pages.application.constants.4': '基于Ant Design的管理后台模板',
  'auto.pages.pages.application.constants.5': 'React电商模板',
  'auto.pages.pages.application.constants.6': '电商网站模板',
  'auto.pages.pages.application.constants.7': 'Vue3 Web应用',
  'auto.pages.pages.application.constants.8': '使用Vue3框架开发的Web应用程序',
  'auto.pages.pages.application.constants.9': 'Vue3管理后台模板',
  'auto.pages.pages.application.constants.10': '基于ElementPlus的管理后台模板',
  'auto.pages.pages.application.constants.11': 'Vue2 Web应用',
  'auto.pages.pages.application.constants.12': '使用Vue2框架开发的Web应用程序',
  'auto.pages.pages.application.constants.13': 'Next.js应用',
  'auto.pages.pages.application.constants.14':
    '使用Next.js框架开发的React应用程序',
  'auto.pages.pages.application.constants.15': '若依管理后台应用（Vu3）',
  'auto.pages.pages.application.constants.16':
    '基于 Vue3 + element-plus 实现的管理后台',
  'auto.pages.pages.application.constants.17': '前端 微应用',
  'auto.pages.pages.application.constants.18': '用于珊瑚云平台的前端微应用',
  'auto.pages.pages.application.constants.19': '后端 微应用',
  'auto.pages.pages.application.constants.20': '用于珊瑚云平台的后端微应用',
  'auto.pages.pages.application.constants.21': '微信小程序',
  'auto.pages.pages.application.constants.22': '微信平台上的轻量级应用',
  'auto.pages.pages.application.constants.23': '支付宝小程序',
  'auto.pages.pages.application.constants.24': '支付宝平台上的轻量级应用',
  'auto.pages.pages.application.constants.25': '百度小程序',
  'auto.pages.pages.application.constants.26': '百度平台上的轻量级应用',
  'auto.pages.pages.application.constants.27': 'Uniapp应用',
  'auto.pages.pages.application.constants.28':
    '使用Vue.js开发所有前端应用的框架',
  'auto.pages.pages.application.constants.29': 'Taro应用',
  'auto.pages.pages.application.constants.30': '开放式跨端跨框架解决方案',
  'auto.pages.pages.application.constants.31': 'iOS应用',
  'auto.pages.pages.application.constants.32': 'iOS原生应用开发',
  'auto.pages.pages.application.constants.33': 'Android应用',
  'auto.pages.pages.application.constants.34': 'Android原生应用开发',
  'auto.pages.pages.application.constants.35': 'Java应用',
  'auto.pages.pages.application.constants.36': 'Java后端应用开发',
  'auto.pages.pages.application.constants.37': 'Node.js应用',
  'auto.pages.pages.application.constants.38': 'Node.js后端应用开发',
  'auto.pages.pages.application.constants.39': 'Python应用',
  'auto.pages.pages.application.constants.40': 'Python后端应用开发',
  'auto.pages.pages.application.constants.41': 'C/C++应用',
  'auto.pages.pages.application.constants.42': 'C/C++应用开发',
  'auto.pages.pages.application.constants.43': '若依管理后台应用',
  'auto.pages.pages.application.constants.44': '基于 Spring Boot 多模块架构',
  'auto.pages.pages.application.constants.45': 'Electron应用',
  'auto.pages.pages.application.constants.46': '使用Electron开发的桌面应用程序',
  'auto.pages.pages.application.constants.47': '桌面应用',
  'auto.pages.pages.application.constants.48': '原生桌面应用程序',
  'auto.pages.pages.application.constants.49': 'RESTful API服务',
  'auto.pages.pages.application.constants.50': 'GraphQL API服务',
  'auto.pages.pages.application.constants.51': '微服务',
  'auto.pages.pages.application.constants.52': '微服务架构应用',
  'auto.pages.pages.application.constants.53': '前端',
  'auto.pages.pages.application.constants.54': '小程序',
  'auto.pages.pages.application.constants.55': '移动端',
  'auto.pages.pages.application.constants.56': '后端',
  'auto.pages.pages.application.constants.57': '桌面应用',
  'auto.pages.pages.application.constants.58': 'API服务',
  'auto.pages.pages.application.constants.59': '珊瑚礁',
  'auto.pages.pages.application.constants.60': '微服务',
  'auto.pages.pages.application.constants.61': '移动端微应用',
  'auto.pages.pages.application.constants.62': '用于珊瑚云平台的移动端微应用',
  'auto.pages.pages.application.constants.65': 'Frontend NPM Package',
  'auto.pages.pages.application.constants.66':
    'Storybook application for developing frontend components and publishing NPM packages',
  'auto.pages.pages.application.index.1': '加载应用列表失败',
  'auto.pages.pages.application.index.2': '暂无应用描述',
  'auto.pages.pages.application.index.3': '更新:',
  'auto.pages.pages.application.index.4': '开发应用',
  'auto.pages.pages.application.index.5': '预览应用',
  'auto.pages.pages.application.index.6': '编辑应用',
  'auto.pages.pages.application.index.7': '确定',
  'auto.pages.pages.application.index.8': '取消',
  'auto.pages.pages.application.index.9': '删除应用',
  'auto.pages.pages.application.index.10': '搜索应用名称/标识符',
  'auto.pages.pages.application.index.11': '共 {p1} 个应用',
  'auto.pages.pages.application.index.12': '暂无应用数据',
  'auto.pages.pages.architecture.api-management.index.1': '项目管理',
  'auto.pages.pages.architecture.api-management.index.2': '查询项目列表',
  'auto.pages.pages.architecture.api-management.index.3': '需求管理',
  'auto.pages.pages.architecture.api-management.index.4': '创建需求项',
  'auto.pages.pages.architecture.api-management.index.5': '公告管理',
  'auto.pages.pages.architecture.api-management.index.6': '发布项目公告',
  'auto.pages.pages.architecture.api-management.index.7': '模块',
  'auto.pages.pages.architecture.api-management.index.8': '接口名称',
  'auto.pages.pages.architecture.api-management.index.9': '状态',
  'auto.pages.pages.architecture.api-management.index.10': '设计中',
  'auto.pages.pages.architecture.api-management.index.11': '开发中',
  'auto.pages.pages.architecture.api-management.index.12': '已发布',
  'auto.pages.pages.architecture.api-management.index.13': '接口管理',
  'auto.pages.pages.architecture.api-management.index.14':
    '接口定义、状态跟踪与版本协同',
  'auto.pages.pages.architecture.code-management.index.1': '前端组',
  'auto.pages.pages.architecture.code-management.index.2': '后端组',
  'auto.pages.pages.architecture.code-management.index.3': '平台组',
  'auto.pages.pages.architecture.code-management.index.4': '代码仓库',
  'auto.pages.pages.architecture.code-management.index.5': '主分支',
  'auto.pages.pages.architecture.code-management.index.6': '责任团队',
  'auto.pages.pages.architecture.code-management.index.7': '最近更新',
  'auto.pages.pages.architecture.code-management.index.8': '代码管理',
  'auto.pages.pages.architecture.code-management.index.9':
    '代码仓库、分支策略与模块归属管理',
  'auto.pages.pages.architecture.detail.index.1': '获取项目列表',
  'auto.pages.pages.architecture.detail.index.2': '保存需求概要',
  'auto.pages.pages.architecture.detail.index.3': '同步沟通记录',
  'auto.pages.pages.architecture.detail.index.4': '接口',
  'auto.pages.pages.architecture.detail.index.5': '服务',
  'auto.pages.pages.architecture.detail.index.6': '详细设计',
  'auto.pages.pages.architecture.detail.index.7':
    '接口、数据结构与关键流程的可实施说明',
  'auto.pages.pages.architecture.detail.index.8': '核心设计参数',
  'auto.pages.pages.architecture.detail.index.9': '事件最终一致性',
  'auto.pages.pages.architecture.detail.index.10': 'Redis 10 分钟缓存',
  'auto.pages.pages.architecture.detail.index.11': '全链路操作审计',
  'auto.pages.pages.architecture.detail.index.12': '鉴权方案',
  'auto.pages.pages.architecture.detail.index.13': '一致性策略',
  'auto.pages.pages.architecture.detail.index.14': '缓存策略',
  'auto.pages.pages.architecture.detail.index.15': '审计方案',
  'auto.pages.pages.architecture.detail.index.16': '接口清单',
  'auto.pages.pages.architecture.overview.index.1': '概要设计',
  'auto.pages.pages.architecture.overview.index.2':
    '系统边界、核心模块与关键技术选型',
  'auto.pages.pages.architecture.overview.index.3':
    '本页为架构总览，重点聚焦模块边界和交互关系。',
  'auto.pages.pages.architecture.overview.index.4': '系统概要',
  'auto.pages.pages.architecture.overview.index.5':
    '项目管理平台 + 记录易 + 知识管理系统',
  'auto.pages.pages.architecture.overview.index.6':
    '外部平台限流与权限同步延迟',
  'auto.pages.pages.architecture.overview.index.7': '系统边界',
  'auto.pages.pages.architecture.overview.index.8': '技术栈',
  'auto.pages.pages.architecture.overview.index.9': '可用性目标',
  'auto.pages.pages.architecture.overview.index.10': '部署方式',
  'auto.pages.pages.architecture.overview.index.11': '集成方式',
  'auto.pages.pages.architecture.overview.index.12': '主要风险',
  'auto.pages.pages.architecture.overview.index.13': '模块划分',
  'auto.pages.pages.architecture.overview.index.14':
    '1. 项目域：项目列表、项目详情、项目统计。 2.\n          需求域：需求概要、功能清单、需求文档。 3.\n          交付域：原型、架构、测试、质量。 4. 资产域：知识库、素材库、文件管理。',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.1':
    '默认字幕',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.2':
    '此文件格式暂不支持直接预览。',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.3':
    '下载文件',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.4':
    '预览',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.5':
    '关闭',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.6':
    '下载',
  'auto.component.pages.asset-library.components.UploadMaterialModal.1':
    '请选择文件',
  'auto.component.pages.asset-library.components.UploadMaterialModal.2':
    '上传成功',
  'auto.component.pages.asset-library.components.UploadMaterialModal.3':
    '上传失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.4':
    '上传完成，但有 {p1} 个文件失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.5':
    '上传失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.6':
    '上传素材',
  'auto.component.pages.asset-library.components.UploadMaterialModal.7': '取消',
  'auto.component.pages.asset-library.components.UploadMaterialModal.8':
    '上传中',
  'auto.component.pages.asset-library.components.UploadMaterialModal.9':
    '开始上传',
  'auto.component.pages.asset-library.components.UploadMaterialModal.10':
    '上传目录',
  'auto.component.pages.asset-library.components.UploadMaterialModal.11':
    '选择上传目录',
  'auto.component.pages.asset-library.components.UploadMaterialModal.12':
    '存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.13':
    '请选择存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.14':
    '选择存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.15':
    '选择文件',
  'auto.component.pages.asset-library.components.UploadMaterialModal.16':
    '点击或拖拽文件到此区域上传',
  'auto.component.pages.asset-library.components.UploadMaterialModal.17':
    '支持批量上传',
  'auto.pages.pages.asset-library.index.1': '文件夹删除成功',
  'auto.pages.pages.asset-library.index.2': '删除失败',
  'auto.pages.pages.asset-library.index.3': '存储配置创建成功',
  'auto.pages.pages.asset-library.index.4': '创建存储配置失败',
  'auto.pages.pages.asset-library.index.5': '新增子集文件夹',
  'auto.pages.pages.asset-library.index.6': '编辑文件夹',
  'auto.pages.pages.asset-library.index.7': '确定要删除该文件夹吗？',
  'auto.pages.pages.asset-library.index.8': '删除文件夹',
  'auto.pages.pages.asset-library.index.9': '文件夹更新及排序成功',
  'auto.pages.pages.asset-library.index.10': '文件夹操作失败',
  'auto.pages.pages.asset-library.index.11': '文件夹更新成功',
  'auto.pages.pages.asset-library.index.12': '文件夹创建成功',
  'auto.pages.pages.asset-library.index.13': '操作失败',
  'auto.pages.pages.asset-library.index.14': '视频',
  'auto.pages.pages.asset-library.index.15': '文档',
  'auto.pages.pages.asset-library.index.16': '其他',
  'auto.pages.pages.asset-library.index.17': '预览',
  'auto.pages.pages.asset-library.index.18': '确认删除？',
  'auto.pages.pages.asset-library.index.19': '删除成功',
  'auto.pages.pages.asset-library.index.20': '删除',
  'auto.pages.pages.asset-library.index.21': '文件夹',
  'auto.pages.pages.asset-library.index.22': '取消选择',
  'auto.pages.pages.asset-library.index.23': '确认删除选中的 {p1} 个素材吗？',
  'auto.pages.pages.asset-library.index.24': '批量删除成功',
  'auto.pages.pages.asset-library.index.25': '批量删除失败',
  'auto.pages.pages.asset-library.index.26': '批量删除',
  'auto.pages.pages.asset-library.index.27': '编辑文件夹',
  'auto.pages.pages.asset-library.index.28': '新建文件夹',
  'auto.pages.pages.asset-library.index.29': '文件夹名称',
  'auto.pages.pages.asset-library.index.30': '请输入文件夹名称',
  'auto.pages.pages.asset-library.index.31': '请输入名称',
  'auto.pages.pages.asset-library.index.32': '上级文件夹',
  'auto.pages.pages.asset-library.index.33':
    '请选择上级文件夹（不选则为根目录）',
  'auto.pages.pages.asset-library.index.34': '排序',
  'auto.pages.pages.asset-library.index.35': '创建存储配置',
  'auto.pages.pages.asset-library.index.36': '配置名称',
  'auto.pages.pages.asset-library.index.37': '请输入配置名称',
  'auto.pages.pages.asset-library.index.38': '请输入配置名称',
  'auto.pages.pages.asset-library.index.39': '存储类型',
  'auto.pages.pages.asset-library.index.40': '请选择存储类型',
  'auto.pages.pages.asset-library.index.41': '请选择存储类型',
  'auto.pages.pages.asset-library.index.42': '端点地址',
  'auto.pages.pages.asset-library.index.43': '请输入端点地址',
  'auto.pages.pages.asset-library.index.44': '请输入端点地址',
  'auto.pages.pages.asset-library.index.45': '存储桶',
  'auto.pages.pages.asset-library.index.46': '请输入存储桶名称',
  'auto.pages.pages.asset-library.index.47': '请输入存储桶名称',
  'auto.pages.pages.asset-library.index.48': '区域',
  'auto.pages.pages.asset-library.index.49': '请输入区域（可选）',
  'auto.pages.pages.asset-library.index.50': '请输入 Access Key',
  'auto.pages.pages.asset-library.index.51': '请输入 Access Key',
  'auto.pages.pages.asset-library.index.52': '请输入 Secret Key',
  'auto.pages.pages.asset-library.index.53': '请输入 Secret Key',
  'auto.pages.pages.asset-library.index.54': '基础路径',
  'auto.pages.pages.asset-library.index.55': '请输入基础路径（可选）',
  'auto.pages.pages.asset-library.index.56': 'CDN 域名',
  'auto.pages.pages.asset-library.index.57': '请输入 CDN 域名（可选）',
  'auto.pages.pages.asset-library.index.58': '存储配额',
  'auto.pages.pages.asset-library.index.59': '请输入存储配额',
  'auto.pages.pages.asset-library.index.60': '单位',
  'auto.pages.pages.asset-library.index.61': '请选择单位',
  'auto.pages.pages.asset-library.index.62': '请选择单位',
  'auto.pages.pages.asset-library.index.63': '设为默认',
  'auto.pages.pages.asset-library.index.64': '管理员权限',
  'auto.pages.pages.asset-library.index.65': '只有管理员才能修改此配置',
  'auto.pages.pages.audit-log.index.1': '没有可导出的数据',
  'auto.pages.pages.audit-log.index.2': '导出成功',
  'auto.pages.pages.audit-log.index.3': '导出失败',
  'auto.pages.pages.audit-log.index.4': '导出为 XLSX',
  'auto.pages.pages.audit-log.index.5': '导出为 CSV',
  'auto.pages.pages.audit-log.index.6': '导出',
  'auto.pages.pages.code-management.dependency-analysis.index.1':
    '保持当前版本，定期关注安全公告',
  'auto.pages.pages.code-management.dependency-analysis.index.2':
    '建议升级至 4.17.21 以上以修复已知漏洞',
  'auto.pages.pages.code-management.dependency-analysis.index.3':
    '与团队规范版本统一，减少规则漂移',
  'auto.pages.pages.code-management.dependency-analysis.index.4': '依赖包',
  'auto.pages.pages.code-management.dependency-analysis.index.5': '版本',
  'auto.pages.pages.code-management.dependency-analysis.index.6': '类型',
  'auto.pages.pages.code-management.dependency-analysis.index.7': '生产依赖',
  'auto.pages.pages.code-management.dependency-analysis.index.8': '开发依赖',
  'auto.pages.pages.code-management.dependency-analysis.index.9': '风险等级',
  'auto.pages.pages.code-management.dependency-analysis.index.10': '高',
  'auto.pages.pages.code-management.dependency-analysis.index.11': '中',
  'auto.pages.pages.code-management.dependency-analysis.index.12': '低',
  'auto.pages.pages.code-management.dependency-analysis.index.13': '处理建议',
  'auto.pages.pages.code-management.dependency-analysis.index.14': '依赖分析',
  'auto.pages.pages.code-management.dependency-analysis.index.15':
    '分析项目依赖关系、风险等级与升级建议',
  'auto.pages.pages.communication-records.index.1': '会议',
  'auto.pages.pages.communication-records.index.2': '电话',
  'auto.pages.pages.communication-records.index.3': '邮件',
  'auto.pages.pages.communication-records.index.4': '微信',
  'auto.pages.pages.communication-records.index.5': '其他',
  'auto.pages.pages.communication-records.index.6': '待处理',
  'auto.pages.pages.communication-records.index.7': '进行中',
  'auto.pages.pages.communication-records.index.8': '已交付',
  'auto.pages.pages.communication-records.index.9': '已归档',
  'auto.pages.pages.communication-records.index.10': '待处理',
  'auto.pages.pages.communication-records.index.11': '进行中',
  'auto.pages.pages.communication-records.index.12': '已交付',
  'auto.pages.pages.communication-records.index.13': '已归档',
  'auto.pages.pages.communication-records.index.14': '会议',
  'auto.pages.pages.communication-records.index.15': '电话',
  'auto.pages.pages.communication-records.index.16': '邮件',
  'auto.pages.pages.communication-records.index.17': '微信',
  'auto.pages.pages.communication-records.index.18': '其他',
  'auto.pages.pages.communication-records.index.19': '待处理',
  'auto.pages.pages.communication-records.index.20': '进行中',
  'auto.pages.pages.communication-records.index.21': '已交付',
  'auto.pages.pages.communication-records.index.22': '已归档',
  'auto.pages.pages.communication-records.index.23': '会议',
  'auto.pages.pages.communication-records.index.24': '电话',
  'auto.pages.pages.communication-records.index.25': '邮件',
  'auto.pages.pages.communication-records.index.26': '微信',
  'auto.pages.pages.communication-records.index.27': '其他',
  'auto.pages.pages.communication-records.index.28': '待处理',
  'auto.pages.pages.communication-records.index.29': '进行中',
  'auto.pages.pages.communication-records.index.30': '已交付',
  'auto.pages.pages.communication-records.index.31': '已归档',
  'auto.pages.pages.daily-report-management.index.1': '张三',
  'auto.pages.pages.daily-report-management.index.2':
    '完成登录模块 SSO 对接并联调通过',
  'auto.pages.pages.daily-report-management.index.3': '待确认单点退出策略',
  'auto.pages.pages.daily-report-management.index.4': '李四',
  'auto.pages.pages.daily-report-management.index.5':
    '完成需求文档结构优化并同步评审意见',
  'auto.pages.pages.daily-report-management.index.6': '第三方接口返回字段变化',
  'auto.pages.pages.daily-report-management.index.7': '王五',
  'auto.pages.pages.daily-report-management.index.8':
    '推进核心流程自动化测试脚本编写',
  'auto.pages.pages.daily-report-management.index.9':
    '测试环境数据库数据不稳定',
  'auto.pages.pages.daily-report-management.index.10': '日期',
  'auto.pages.pages.daily-report-management.index.11': '汇报人',
  'auto.pages.pages.daily-report-management.index.12': '今日进展',
  'auto.pages.pages.daily-report-management.index.13': '风险/阻塞',
  'auto.pages.pages.daily-report-management.index.14': '状态',
  'auto.pages.pages.daily-report-management.index.15': '草稿',
  'auto.pages.pages.daily-report-management.index.16': '已提交',
  'auto.pages.pages.daily-report-management.index.17': '已审阅',
  'auto.pages.pages.daily-report-management.index.18': '日报管理',
  'auto.pages.pages.daily-report-management.index.19':
    '团队日报沉淀、风险同步与进展追踪',
  'auto.pages.pages.data-modeling.entity-management.index.1': '未命名项目',
  'auto.pages.pages.data-modeling.entity-management.index.2':
    '加载实体管理失败',
  'auto.pages.pages.data-modeling.entity-management.index.3':
    '当前未识别到项目，请先切换项目',
  'auto.pages.pages.data-modeling.entity-management.index.4': '保存成功',
  'auto.pages.pages.data-modeling.entity-management.index.5': '保存失败',
  'auto.pages.pages.data-modeling.entity-management.index.6':
    '当前未识别到项目，请先切换项目',
  'auto.pages.pages.data-modeling.entity-management.index.7': '已清空实体',
  'auto.pages.pages.data-modeling.entity-management.index.8': '清空失败',
  'auto.pages.pages.data-modeling.entity-management.index.9':
    '实体定义JSON中缺少 name（实体名称），无法保存',
  'auto.pages.pages.data-modeling.entity-management.index.10': '未填写',
  'auto.pages.pages.data-modeling.entity-management.index.11': '实体名称',
  'auto.pages.pages.data-modeling.entity-management.index.12': '未填写',
  'auto.pages.pages.data-modeling.entity-management.index.13': '实体标识符',
  'auto.pages.pages.data-modeling.entity-management.index.14': '应用UUID',
  'auto.pages.pages.data-modeling.entity-management.index.15': '实体UUID',
  'auto.pages.pages.data-modeling.entity-management.index.16': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.17': '操作',
  'auto.pages.pages.data-modeling.entity-management.index.18': '编辑',
  'auto.pages.pages.data-modeling.entity-management.index.19': '删除',
  'auto.pages.pages.data-modeling.entity-management.index.20': '实体管理',
  'auto.pages.pages.data-modeling.entity-management.index.21':
    '管理项目“{p1}”的实体定义',
  'auto.pages.pages.data-modeling.entity-management.index.22': '新增实体',
  'auto.pages.pages.data-modeling.entity-management.index.23': '保存',
  'auto.pages.pages.data-modeling.entity-management.index.24':
    '确认清空当前项目实体数据？',
  'auto.pages.pages.data-modeling.entity-management.index.25': '清空重置',
  'auto.pages.pages.data-modeling.entity-management.index.26': '删除选中（',
  'auto.pages.pages.data-modeling.entity-management.index.27':
    '暂无实体，点击“新增实体”开始',
  'auto.pages.pages.data-modeling.entity-management.index.28': '编辑实体',
  'auto.pages.pages.data-modeling.entity-management.index.29': '新增实体',
  'auto.pages.pages.data-modeling.entity-management.index.30': '确定',
  'auto.pages.pages.data-modeling.entity-management.index.31': '取消',
  'auto.pages.pages.data-modeling.entity-management.index.32':
    '应用UUID（可选）',
  'auto.pages.pages.data-modeling.entity-management.index.33': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.34':
    '请输入实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.35':
    'JSON 格式不合法',
  'auto.pages.pages.data-modeling.entity-management.index.36':
    '粘贴实体定义 JSON',
  'auto.pages.pages.data-modeling.entity-management.index.37':
    '提示：实体UUID、名称、标识符会在保存时从 JSON 自动解析。',
  'auto.pages.pages.data-modeling.index.1': '未命名项目',
  'auto.pages.pages.data-modeling.index.2': '加载数据建模失败',
  'auto.pages.pages.data-modeling.index.3':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.4': '项目信息已保存',
  'auto.pages.pages.data-modeling.index.5': '保存项目信息失败',
  'auto.pages.pages.data-modeling.index.6':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.7':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.data-modeling.index.8': 'AI 生成失败',
  'auto.pages.pages.data-modeling.index.9':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.10': '请先勾选预览实体',
  'auto.pages.pages.data-modeling.index.11': '已添加并保存 {p1} 个实体',
  'auto.pages.pages.data-modeling.index.12': '添加失败',
  'auto.pages.pages.data-modeling.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.14': '保存成功',
  'auto.pages.pages.data-modeling.index.15': '保存失败',
  'auto.pages.pages.data-modeling.index.16':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.17': '已清空数据建模实体',
  'auto.pages.pages.data-modeling.index.18': '清空失败',
  'auto.pages.pages.data-modeling.index.19':
    '实体定义JSON中缺少 name（实体名称），无法保存',
  'auto.pages.pages.data-modeling.index.20': '未填写',
  'auto.pages.pages.data-modeling.index.21': '实体名称',
  'auto.pages.pages.data-modeling.index.22': '未填写',
  'auto.pages.pages.data-modeling.index.23': '实体标识符',
  'auto.pages.pages.data-modeling.index.24': '应用UUID',
  'auto.pages.pages.data-modeling.index.25': '实体UUID',
  'auto.pages.pages.data-modeling.index.26': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.27': '操作',
  'auto.pages.pages.data-modeling.index.28': '编辑',
  'auto.pages.pages.data-modeling.index.29': '删除',
  'auto.pages.pages.data-modeling.index.30': '实体名称',
  'auto.pages.pages.data-modeling.index.31': '未填写',
  'auto.pages.pages.data-modeling.index.32': '实体标识符',
  'auto.pages.pages.data-modeling.index.33': '应用UUID',
  'auto.pages.pages.data-modeling.index.34': '实体UUID',
  'auto.pages.pages.data-modeling.index.35': '实体管理',
  'auto.pages.pages.data-modeling.index.36': 'AI辅助建模',
  'auto.pages.pages.data-modeling.index.37': '管理项目“{p1}”下的实体定义(JSON)',
  'auto.pages.pages.data-modeling.index.38':
    '基于项目“{p1}”进行实体拆解与字段AI辅助建模',
  'auto.pages.pages.data-modeling.index.39': 'AIAI辅助建模',
  'auto.pages.pages.data-modeling.index.40': '新增实体',
  'auto.pages.pages.data-modeling.index.41': '保存',
  'auto.pages.pages.data-modeling.index.42': '确认清空当前项目实体数据？',
  'auto.pages.pages.data-modeling.index.43': '清空重置',
  'auto.pages.pages.data-modeling.index.44': '删除选中（',
  'auto.pages.pages.data-modeling.index.45':
    '暂无实体，点击“AIAI辅助建模”或“新增实体”开始',
  'auto.pages.pages.data-modeling.index.46': '暂无实体，点击“新增实体”开始',
  'auto.pages.pages.data-modeling.index.47': '编辑实体',
  'auto.pages.pages.data-modeling.index.48': '新增实体',
  'auto.pages.pages.data-modeling.index.49': '确定',
  'auto.pages.pages.data-modeling.index.50': '取消',
  'auto.pages.pages.data-modeling.index.51': '应用UUID（可选）',
  'auto.pages.pages.data-modeling.index.52': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.53': '请输入实体定义JSON',
  'auto.pages.pages.data-modeling.index.54': 'JSON 格式不合法',
  'auto.pages.pages.data-modeling.index.55': '粘贴实体定义 JSON',
  'auto.pages.pages.data-modeling.index.56':
    '提示：实体UUID、名称、标识符会在保存时从 JSON 自动解析。',
  'auto.pages.pages.data-modeling.index.57': 'AI AI辅助建模',
  'auto.pages.pages.data-modeling.index.58': '生成选项',
  'auto.pages.pages.data-modeling.index.59': '项目名称',
  'auto.pages.pages.data-modeling.index.60': '请输入项目名称',
  'auto.pages.pages.data-modeling.index.61': '请输入项目名称',
  'auto.pages.pages.data-modeling.index.62': '项目简介',
  'auto.pages.pages.data-modeling.index.63': '请输入项目简介',
  'auto.pages.pages.data-modeling.index.64': '提示信息（用于辅助生成）',
  'auto.pages.pages.data-modeling.index.65':
    '例如：重点分析主数据、交易数据、审计日志等实体',
  'auto.pages.pages.data-modeling.index.66': '拆解实体数量',
  'auto.pages.pages.data-modeling.index.67': '请输入拆解数量',
  'auto.pages.pages.data-modeling.index.68': '数量范围为 1-40',
  'auto.pages.pages.data-modeling.index.69':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.data-modeling.index.70': '保存项目信息',
  'auto.pages.pages.data-modeling.index.71': '取消',
  'auto.pages.pages.data-modeling.index.72': '生成预览',
  'auto.pages.pages.data-modeling.index.73': '预览结果',
  'auto.pages.pages.data-modeling.index.74': '勾选需要的实体后添加到列表',
  'auto.pages.pages.data-modeling.index.75': '点击“生成预览”后查看候选实体',
  'auto.pages.pages.data-modeling.index.76': '重名时覆盖已有实体',
  'auto.pages.pages.data-modeling.index.77': '添加选中到实体列表（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.1':
    '建议字段包括：{p1}。',
  'auto.pages.pages.data-modeling.modeling-assistant.index.2': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.3': '未识别项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.4':
    '加载建模辅助失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.5':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.6': '项目信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.7':
    '保存项目信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.8': '项目信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.9':
    '保存项目信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.10':
    '实体信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.11':
    '实体信息已保存到预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.12':
    '保存实体信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.14':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.data-modeling.modeling-assistant.index.15': 'AI 生成失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.16':
    '字段描述预览已生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.17':
    '生成字段描述失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.18':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.19':
    '请先生成字段描述预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.20':
    '缺少实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.21':
    '字段已保存：新增 {p1}，覆盖 {p2}，跳过 {p3}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.22': '保存字段失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.23':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.24': '字段详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.25':
    '加载字段详情失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.26':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.27': '缺少实体名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.28':
    '请至少保留一个字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.29':
    '字段修改已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.30': '保存字段失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.31':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.32':
    '请先勾选预览实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.33':
    '已添加并保存 {p1} 个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.34': '添加失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.35':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.36': '保存成功',
  'auto.pages.pages.data-modeling.modeling-assistant.index.37': '保存失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.38':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.39':
    '已清空建模辅助列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.40': '清空失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.41': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.42': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.43': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.44': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.45': '主要字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.46': '未生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.47': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.48': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.49': '查看字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.50': '编辑',
  'auto.pages.pages.data-modeling.modeling-assistant.index.51': '删除',
  'auto.pages.pages.data-modeling.modeling-assistant.index.52': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.53': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.54': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.55': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.56': '主要字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.57': '未生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.58': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.59': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.60': '建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.61':
    '基于项目名称、简介和功能清单，发现业务实体并逐个分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.62': 'AI建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.63': '新增实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.64': '保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.65':
    '确认清空当前建模辅助列表？',
  'auto.pages.pages.data-modeling.modeling-assistant.index.66': '清空重置',
  'auto.pages.pages.data-modeling.modeling-assistant.index.67': '删除选中（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.68':
    '暂无建模实体，点击“AI建模辅助”或“新增实体”开始',
  'auto.pages.pages.data-modeling.modeling-assistant.index.69': '编辑实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.70': '新增实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.71': '确定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.72': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.73': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.74':
    '请输入实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.75': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.76': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.77': '主要字段描述',
  'auto.pages.pages.data-modeling.modeling-assistant.index.78':
    '例如：建议包含客户编号、状态、创建时间等字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.79': 'AI 建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.80': '生成选项',
  'auto.pages.pages.data-modeling.modeling-assistant.index.81': '项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.82':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.83':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.84': '项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.85':
    '请输入项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.86':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.87':
    '例如：重点补充主数据、交易实体、结算实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.88': '拆解实体数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.89':
    '请输入拆解数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.90':
    '数量范围为 1-40',
  'auto.pages.pages.data-modeling.modeling-assistant.index.91':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.92': '保存项目信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.93': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.94': '生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.95': '预览结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.96':
    '勾选需要的实体后添加到列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.97':
    '点击“生成预览”后查看候选实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.98':
    '重名时覆盖已有实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.99':
    '添加选中到实体列表（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.100': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.101': '分析选项',
  'auto.pages.pages.data-modeling.modeling-assistant.index.102': '项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.103':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.104': '项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.105': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.106':
    '请输入实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.107': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.108': '实体简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.109': '主要字段描述',
  'auto.pages.pages.data-modeling.modeling-assistant.index.110':
    '提示信息（用于辅助分析）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.111':
    '例如：强调索引建议、状态流转字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.112': '数据库类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.113': '保存项目信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.114': '保存实体信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.115': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.116': '生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.117': '预览结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.118':
    '确认后存入独立字段分析表（不回写实体详细字段）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.119': '字段中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.120': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.121': '字段英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.122': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.123': 'MySQL类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.124': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.125': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.126': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.127': '必填',
  'auto.pages.pages.data-modeling.modeling-assistant.index.128': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.129': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.130': '未定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.131': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.132': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.133': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.134': '未定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.135':
    '点击“生成预览”后查看字段建议',
  'auto.pages.pages.data-modeling.modeling-assistant.index.136': '覆盖',
  'auto.pages.pages.data-modeling.modeling-assistant.index.137': '追加',
  'auto.pages.pages.data-modeling.modeling-assistant.index.138':
    '追加时覆盖已有重名字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.139': '保存到字段库',
  'auto.pages.pages.data-modeling.modeling-assistant.index.140':
    '{p1} - 字段详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.141': '新增字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.142': '保存字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.143':
    '字段加载中...',
  'auto.pages.pages.data-modeling.modeling-assistant.index.144':
    '暂无字段，请点击“新增字段”或先执行AI分析',
  'auto.pages.pages.data-modeling.modeling-assistant.index.145': '字段中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.146': '如：客户编号',
  'auto.pages.pages.data-modeling.modeling-assistant.index.147': '字段英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.148':
    '如：customerCode',
  'auto.pages.pages.data-modeling.modeling-assistant.index.149': 'MySQL类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.150':
    '如：varchar(255)',
  'auto.pages.pages.data-modeling.modeling-assistant.index.151': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.152': '字段说明',
  'auto.pages.pages.data-modeling.modeling-assistant.index.153': '必填',
  'auto.pages.pages.data-modeling.modeling-assistant.index.154': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.155': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.156': '下方插入',
  'auto.pages.pages.data-modeling.modeling-assistant.index.157': '删除',
  'auto.pages.pages.external-redirect.index.1': '正在跳转...',
  'auto.pages.pages.knowledge-base.index.1': '项目需求分析模板',
  'auto.pages.pages.knowledge-base.index.2': '架构评审规范',
  'auto.pages.pages.knowledge-base.index.3': '架构组',
  'auto.pages.pages.knowledge-base.index.4': '上线回滚预案',
  'auto.pages.pages.knowledge-base.index.5': '文档标题',
  'auto.pages.pages.knowledge-base.index.6': '分类',
  'auto.pages.pages.knowledge-base.index.7': '模板',
  'auto.pages.pages.knowledge-base.index.8': '规范',
  'auto.pages.pages.knowledge-base.index.9': '运行手册',
  'auto.pages.pages.knowledge-base.index.10': '维护人',
  'auto.pages.pages.knowledge-base.index.11': '版本',
  'auto.pages.pages.knowledge-base.index.12': '更新时间',
  'auto.pages.pages.knowledge-base.index.13': '操作',
  'auto.pages.pages.knowledge-base.index.14': '查看',
  'auto.pages.pages.knowledge-base.index.15': '编辑',
  'auto.pages.pages.knowledge-base.index.16': '知识库',
  'auto.pages.pages.knowledge-base.index.17':
    '对接企业知识管理系统（文件管理）',
  'auto.pages.pages.knowledge-base.index.18': '上传文档',
  'auto.pages.pages.knowledge-base.index.19': '新建知识',
  'auto.pages.pages.knowledge-base.reference-materials.index.1':
    '参考链接已添加',
  'auto.pages.pages.knowledge-base.reference-materials.index.2':
    '参考文字已记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.3': '参考资料',
  'auto.pages.pages.knowledge-base.reference-materials.index.4':
    '沉淀参考链接、文件/图片与文字记录（后续可对接记录易）',
  'auto.pages.pages.knowledge-base.reference-materials.index.5': '参考链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.6':
    '请输入链接标题',
  'auto.pages.pages.knowledge-base.reference-materials.index.7': '标题',
  'auto.pages.pages.knowledge-base.reference-materials.index.8':
    '请输入链接地址',
  'auto.pages.pages.knowledge-base.reference-materials.index.9':
    '请输入有效 URL（含 http/https）',
  'auto.pages.pages.knowledge-base.reference-materials.index.10': '添加链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.11':
    '暂无参考链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.12': '链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.13':
    '参考文件/图片',
  'auto.pages.pages.knowledge-base.reference-materials.index.14':
    '选择文件或图片',
  'auto.pages.pages.knowledge-base.reference-materials.index.15':
    '暂无已选择文件',
  'auto.pages.pages.knowledge-base.reference-materials.index.16': '文件',
  'auto.pages.pages.knowledge-base.reference-materials.index.17': '文字记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.18': '参考说明',
  'auto.pages.pages.knowledge-base.reference-materials.index.19': '请输入内容',
  'auto.pages.pages.knowledge-base.reference-materials.index.20':
    '记录参考点、竞品优缺点、适配建议等',
  'auto.pages.pages.knowledge-base.reference-materials.index.21': '保存记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.22':
    '暂无文字记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.23': '文字',
  'auto.pages.pages.knowledge-base.reference-products.index.1': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.2': '竞品',
  'auto.pages.pages.knowledge-base.reference-products.index.3': '可替代方案',
  'auto.pages.pages.knowledge-base.reference-products.index.4': '国内',
  'auto.pages.pages.knowledge-base.reference-products.index.5': '国外',
  'auto.pages.pages.knowledge-base.reference-products.index.6': '高',
  'auto.pages.pages.knowledge-base.reference-products.index.7': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.8': '低',
  'auto.pages.pages.knowledge-base.reference-products.index.9': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.10': '竞品',
  'auto.pages.pages.knowledge-base.reference-products.index.11': '可替代方案',
  'auto.pages.pages.knowledge-base.reference-products.index.12': '国内',
  'auto.pages.pages.knowledge-base.reference-products.index.13': '国外',
  'auto.pages.pages.knowledge-base.reference-products.index.14': '高',
  'auto.pages.pages.knowledge-base.reference-products.index.15': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.16': '低',
  'auto.pages.pages.knowledge-base.reference-products.index.17': '未命名项目',
  'auto.pages.pages.knowledge-base.reference-products.index.18':
    '加载参考产品失败',
  'auto.pages.pages.knowledge-base.reference-products.index.19':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.20':
    '项目信息已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.21':
    '保存项目信息失败',
  'auto.pages.pages.knowledge-base.reference-products.index.22':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.23':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.knowledge-base.reference-products.index.24': 'AI 生成失败',
  'auto.pages.pages.knowledge-base.reference-products.index.25':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.26':
    '请先勾选预览产品',
  'auto.pages.pages.knowledge-base.reference-products.index.27':
    '已添加并保存 {p1} 个参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.28': '添加失败',
  'auto.pages.pages.knowledge-base.reference-products.index.29':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.30': '保存成功',
  'auto.pages.pages.knowledge-base.reference-products.index.31': '保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.32':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.33':
    '已清空参考产品数据',
  'auto.pages.pages.knowledge-base.reference-products.index.34': '清空失败',
  'auto.pages.pages.knowledge-base.reference-products.index.35':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.36': '修改已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.37': '新增已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.38': '修改保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.39': '新增保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.40': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.41': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.42': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.43': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.44': '类型',
  'auto.pages.pages.knowledge-base.reference-products.index.45': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.46': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.47': '未区分',
  'auto.pages.pages.knowledge-base.reference-products.index.48': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.49': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.50': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.51': '官网',
  'auto.pages.pages.knowledge-base.reference-products.index.52': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.53': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.54': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.55': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.56': '收费模式',
  'auto.pages.pages.knowledge-base.reference-products.index.57': '备注',
  'auto.pages.pages.knowledge-base.reference-products.index.58': '操作',
  'auto.pages.pages.knowledge-base.reference-products.index.59': '编辑',
  'auto.pages.pages.knowledge-base.reference-products.index.60': '删除',
  'auto.pages.pages.knowledge-base.reference-products.index.61': '列显示',
  'auto.pages.pages.knowledge-base.reference-products.index.62': '重置',
  'auto.pages.pages.knowledge-base.reference-products.index.63': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.64': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.65': '类型',
  'auto.pages.pages.knowledge-base.reference-products.index.66': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.67': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.68': '未区分',
  'auto.pages.pages.knowledge-base.reference-products.index.69': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.70': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.71': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.72': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.73': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.74': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.75': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.76':
    '基于项目“{p1}”沉淀可借鉴产品与竞品分析',
  'auto.pages.pages.knowledge-base.reference-products.index.77': '搜索产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.78': 'AI分析',
  'auto.pages.pages.knowledge-base.reference-products.index.79': '新增',
  'auto.pages.pages.knowledge-base.reference-products.index.80': '保存',
  'auto.pages.pages.knowledge-base.reference-products.index.81':
    '确认清空当前项目参考产品数据？',
  'auto.pages.pages.knowledge-base.reference-products.index.82': '清空',
  'auto.pages.pages.knowledge-base.reference-products.index.83': '删除（',
  'auto.pages.pages.knowledge-base.reference-products.index.84': '刷新',
  'auto.pages.pages.knowledge-base.reference-products.index.85': '紧凑',
  'auto.pages.pages.knowledge-base.reference-products.index.86': '默认',
  'auto.pages.pages.knowledge-base.reference-products.index.87': '宽松',
  'auto.pages.pages.knowledge-base.reference-products.index.88': '调节蜜度',
  'auto.pages.pages.knowledge-base.reference-products.index.89': '列设置',
  'auto.pages.pages.knowledge-base.reference-products.index.90':
    '暂无参考产品数据，点击“AI参考产品分析”或“新增产品”开始',
  'auto.pages.pages.knowledge-base.reference-products.index.91': '共 {p1} 条',
  'auto.pages.pages.knowledge-base.reference-products.index.92': '编辑参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.93': '新增参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.94': '确定',
  'auto.pages.pages.knowledge-base.reference-products.index.95': '取消',
  'auto.pages.pages.knowledge-base.reference-products.index.96': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.97':
    '请输入产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.98':
    '例如：Jira Software',
  'auto.pages.pages.knowledge-base.reference-products.index.99': '产品类型',
  'auto.pages.pages.knowledge-base.reference-products.index.100':
    '请选择产品类型',
  'auto.pages.pages.knowledge-base.reference-products.index.101': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.102': '请选择区域',
  'auto.pages.pages.knowledge-base.reference-products.index.103': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.104':
    '请选择相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.105': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.106':
    '请选择关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.107': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.108':
    '例如：Atlassian',
  'auto.pages.pages.knowledge-base.reference-products.index.109': '官网链接',
  'auto.pages.pages.knowledge-base.reference-products.index.110': '产品定位',
  'auto.pages.pages.knowledge-base.reference-products.index.111': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.112': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.113': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.114': '收费模式',
  'auto.pages.pages.knowledge-base.reference-products.index.115':
    '例如：按用户订阅',
  'auto.pages.pages.knowledge-base.reference-products.index.116': '备注',
  'auto.pages.pages.knowledge-base.reference-products.index.117':
    'AI 参考产品分析',
  'auto.pages.pages.knowledge-base.reference-products.index.118': '生成选项',
  'auto.pages.pages.knowledge-base.reference-products.index.119': '项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.120':
    '请输入项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.121':
    '请输入项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.122': '项目简介',
  'auto.pages.pages.knowledge-base.reference-products.index.123':
    '请输入项目简介',
  'auto.pages.pages.knowledge-base.reference-products.index.124':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.knowledge-base.reference-products.index.125':
    '例如：重点覆盖国内可落地产品，并说明可借鉴能力',
  'auto.pages.pages.knowledge-base.reference-products.index.126':
    '推荐产品数量',
  'auto.pages.pages.knowledge-base.reference-products.index.127': '请输入数量',
  'auto.pages.pages.knowledge-base.reference-products.index.128':
    '数量范围为 1-20',
  'auto.pages.pages.knowledge-base.reference-products.index.129':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.knowledge-base.reference-products.index.130':
    '保存项目信息',
  'auto.pages.pages.knowledge-base.reference-products.index.131': '取消',
  'auto.pages.pages.knowledge-base.reference-products.index.132': '生成预览',
  'auto.pages.pages.knowledge-base.reference-products.index.133': '预览结果',
  'auto.pages.pages.knowledge-base.reference-products.index.134':
    '勾选需要的产品后添加到列表',
  'auto.pages.pages.knowledge-base.reference-products.index.135':
    '点击“生成预览”后查看候选产品',
  'auto.pages.pages.knowledge-base.reference-products.index.136':
    '重名时覆盖已有产品',
  'auto.pages.pages.knowledge-base.reference-products.index.137':
    '添加选中到产品列表（',
  'auto.pages.pages.knowledge-base.reference-products.index.138':
    'Generation strategy',
  'auto.pages.pages.knowledge-base.reference-products.index.139':
    'A. As many as possible',
  'auto.pages.pages.knowledge-base.reference-products.index.140':
    'B. Specified quantity',
  'auto.pages.pages.knowledge-base.reference-products.index.141':
    'C. Manual input',
  'auto.pages.pages.knowledge-base.reference-products.index.142':
    'Manual product list',
  'auto.pages.pages.knowledge-base.reference-products.index.143':
    'Please enter at least one product name',
  'auto.pages.pages.knowledge-base.reference-products.index.144':
    'Enter one product name per line, e.g. Jira Software',
  'auto.pages.pages.knowledge-base.reference-products.index.145':
    '{p1} manually entered candidates generated, select and add',
  'auto.pages.pages.knowledge-base.reference-products.index.146':
    'No valid product names found (check duplicates with existing products)',
  'auto.pages.pages.project.layout.1': '未命名页面',
  'auto.pages.pages.project-home.index.1': '项目主页',
  'auto.pages.pages.project-home.index.2': '项目全局概览与最近动态',
  'auto.pages.pages.project-home.index.3': '应用数',
  'auto.pages.pages.project-home.index.4': '个',
  'auto.pages.pages.project-home.index.5': '代码总行数',
  'auto.pages.pages.project-home.index.6': '行',
  'auto.pages.pages.project-home.index.7': '生成代码总行数',
  'auto.pages.pages.project-home.index.8': '行',
  'auto.pages.pages.project-home.index.9': '代码行数较昨日新增',
  'auto.pages.pages.project-home.index.10': '行',
  'auto.pages.pages.project-home.index.11': '一级功能模块数',
  'auto.pages.pages.project-home.index.12': '个',
  'auto.pages.pages.project-home.index.13': '功能数',
  'auto.pages.pages.project-home.index.14': '个',
  'auto.pages.pages.project-home.index.15': '功能点数',
  'auto.pages.pages.project-home.index.16': '个',
  'auto.pages.pages.project-home.index.17': '角色数',
  'auto.pages.pages.project-home.index.18': '个',
  'auto.pages.pages.project-home.index.19': '概念数',
  'auto.pages.pages.project-home.index.20': '个',
  'auto.pages.pages.project-home.index.21': '项目概况',
  'auto.pages.pages.project-home.index.22': '项目名称',
  'auto.pages.pages.project-home.index.23': '英文名称',
  'auto.pages.pages.project-home.index.24': '标识符',
  'auto.pages.pages.project-home.index.25': '项目简介',
  'auto.pages.pages.project-home.index.26': '创建时间',
  'auto.pages.pages.project-home.index.27': '最近更新',
  'auto.pages.pages.project-home.index.28': '未设置',
  'auto.pages.pages.project-home.index.29': '项目约定',
  'auto.pages.pages.project-home.index.30':
    '当前项目启用中的目标愿景、原则要求与注意事项',
  'auto.pages.pages.project-home.index.31': '最近操作记录',
  'auto.pages.pages.project-home.index.32': '目标愿景',
  'auto.pages.pages.project-home.index.33': '原则要求',
  'auto.pages.pages.project-home.index.34': '注意事项',
  'auto.pages.pages.project-home.index.35': '验收标准',
  'auto.pages.pages.project-home.index.36': '暂无验收标准',
  'auto.pages.pages.project-home.index.37': '最近操作记录',
  'auto.pages.pages.project-home.index.38': '当前暂无最近操作记录',
  'auto.pages.pages.project-settings.developer-options.index.1': '开发者选项',
  'auto.pages.pages.project-settings.developer-options.index.2':
    '开发工具与扩展能力配置',
  'auto.pages.pages.project-settings.developer-options.index.3':
    '开发者选项页面建设中',
  'auto.pages.pages.project-settings.project-announcement.index.1': '项目公告',
  'auto.pages.pages.project-settings.project-announcement.index.2':
    '项目公告发布与历史公告管理',
  'auto.pages.pages.project-settings.project-announcement.index.3':
    '项目公告页面建设中',
  'auto.pages.pages.project-settings.project-collaboration.index.1': '项目协同',
  'auto.pages.pages.project-settings.project-collaboration.index.2':
    '项目协同规则与工作流设置',
  'auto.pages.pages.project-settings.project-collaboration.index.3':
    '项目协同设置页面建设中',
  'auto.pages.pages.project-settings.project-member.index.1': '项目与成员',
  'auto.pages.pages.project-settings.project-member.index.2':
    '项目基本信息与成员协作配置',
  'auto.pages.pages.project-settings.project-member.index.3':
    '项目与成员设置页面建设中',
  'auto.pages.pages.projects.data.1': '解析用户信息失败',
  'auto.pages.pages.projects.estimation-standards.detail.1':
    '估算标准不存在或已删除',
  'auto.pages.pages.projects.estimation-standards.detail.2': '加载标准详情失败',
  'auto.pages.pages.projects.estimation-standards.detail.3': 'AI已生成评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.4':
    'AI生成评分标准失败',
  'auto.pages.pages.projects.estimation-standards.detail.5': 'AI已调整角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.6':
    'AI调整角色比例失败',
  'auto.pages.pages.projects.estimation-standards.detail.7': 'AI已估算基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.8':
    'AI估算基准工时失败',
  'auto.pages.pages.projects.estimation-standards.detail.9':
    'AI标准生成完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.10':
    '批量AI生成评分标准失败',
  'auto.pages.pages.projects.estimation-standards.detail.11':
    'AI比例调整完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.12':
    '批量AI调整比例失败',
  'auto.pages.pages.projects.estimation-standards.detail.13':
    'AI工时估算完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.14':
    '批量AI估算工时失败',
  'auto.pages.pages.projects.estimation-standards.detail.15': '评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.16': '角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.17': '基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.18': '功能点类型代码',
  'auto.pages.pages.projects.estimation-standards.detail.19': '分类',
  'auto.pages.pages.projects.estimation-standards.detail.20': '基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.21':
    '角色比例(%)  P=产品 F=前端 B=后端 T=测试',
  'auto.pages.pages.projects.estimation-standards.detail.22': '操作',
  'auto.pages.pages.projects.estimation-standards.detail.23': '完成',
  'auto.pages.pages.projects.estimation-standards.detail.24': '改',
  'auto.pages.pages.projects.estimation-standards.detail.25':
    '确认删除 {p1} 配置吗？',
  'auto.pages.pages.projects.estimation-standards.detail.26':
    '已删除，保存后生效',
  'auto.pages.pages.projects.estimation-standards.detail.27': '删',
  'auto.pages.pages.projects.estimation-standards.detail.28': 'AI生成评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.29': 'AI标准',
  'auto.pages.pages.projects.estimation-standards.detail.30': 'AI调整角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.31': 'AI比例',
  'auto.pages.pages.projects.estimation-standards.detail.32': 'AI估算基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.33': 'AI工时',
  'auto.pages.pages.projects.estimation-standards.detail.34':
    '标准参数保存成功',
  'auto.pages.pages.projects.estimation-standards.detail.35':
    '保存标准参数失败',
  'auto.pages.pages.projects.estimation-standards.detail.36': '标准参数：{p1}',
  'auto.pages.pages.projects.estimation-standards.detail.37': '标准参数',
  'auto.pages.pages.projects.estimation-standards.detail.38': '版本 v{p1}',
  'auto.pages.pages.projects.estimation-standards.detail.39': '返回列表',
  'auto.pages.pages.projects.estimation-standards.detail.40': 'AI批量标准',
  'auto.pages.pages.projects.estimation-standards.detail.41': 'AI批量比例',
  'auto.pages.pages.projects.estimation-standards.detail.42': 'AI批量工时',
  'auto.pages.pages.projects.estimation-standards.detail.43': '保存参数',
  'auto.pages.pages.projects.estimation-standards.detail.44':
    '复杂度判定标准（可编辑）',
  'auto.pages.pages.projects.estimation-standards.detail.45': '备注',
  'auto.pages.pages.projects.estimation-standards.detail.46': '可选',
  'auto.pages.pages.projects.estimation-standards.detail.47': 'AI{p1}分析',
  'auto.pages.pages.projects.estimation-standards.detail.48': '开始分析',
  'auto.pages.pages.projects.estimation-standards.detail.49': '取消',
  'auto.pages.pages.projects.estimation-standards.detail.50': '目标：',
  'auto.pages.pages.projects.estimation-standards.detail.51': '全部 {p1} 项',
  'auto.pages.pages.projects.estimation-standards.detail.52':
    '请输入你的意见建议，例如：优先稳定性、强调后端性能、提高测试覆盖、避免复杂实现等',
  'auto.pages.pages.projects.estimation-standards.detail.53':
    'AI会在分析时优先考虑你输入的意见；不填则按系统默认规则分析。',
  'auto.pages.pages.projects.estimation-standards.index.1': '加载估算标准失败',
  'auto.pages.pages.projects.estimation-standards.index.2': '估算标准更新成功',
  'auto.pages.pages.projects.estimation-standards.index.3': '估算标准创建成功',
  'auto.pages.pages.projects.estimation-standards.index.4': '保存估算标准失败',
  'auto.pages.pages.projects.estimation-standards.index.5': '标准名称',
  'auto.pages.pages.projects.estimation-standards.index.6': '范围',
  'auto.pages.pages.projects.estimation-standards.index.7': '项目级',
  'auto.pages.pages.projects.estimation-standards.index.8': '全局',
  'auto.pages.pages.projects.estimation-standards.index.9': '状态',
  'auto.pages.pages.projects.estimation-standards.index.10': '启用',
  'auto.pages.pages.projects.estimation-standards.index.11': '禁用',
  'auto.pages.pages.projects.estimation-standards.index.12': '默认',
  'auto.pages.pages.projects.estimation-standards.index.13': '默认',
  'auto.pages.pages.projects.estimation-standards.index.14': '操作',
  'auto.pages.pages.projects.estimation-standards.index.15': '详情',
  'auto.pages.pages.projects.estimation-standards.index.16': '编辑',
  'auto.pages.pages.projects.estimation-standards.index.17':
    '确认删除此估算标准吗？',
  'auto.pages.pages.projects.estimation-standards.index.18': '删除成功',
  'auto.pages.pages.projects.estimation-standards.index.19': '删除',
  'auto.pages.pages.projects.estimation-standards.index.20': '工时评估标准管理',
  'auto.pages.pages.projects.estimation-standards.index.21': '标准列表',
  'auto.pages.pages.projects.estimation-standards.index.22': '刷新',
  'auto.pages.pages.projects.estimation-standards.index.23': '新建标准',
  'auto.pages.pages.projects.estimation-standards.index.24': '编辑估算标准',
  'auto.pages.pages.projects.estimation-standards.index.25': '新建估算标准',
  'auto.pages.pages.projects.estimation-standards.index.26': '标准名称',
  'auto.pages.pages.projects.estimation-standards.index.27': '请输入标准名称',
  'auto.pages.pages.projects.estimation-standards.index.28':
    '例如：中小企业轻量HR/ERP',
  'auto.pages.pages.projects.estimation-standards.index.29': '描述',
  'auto.pages.pages.projects.estimation-standards.index.30': '版本',
  'auto.pages.pages.projects.estimation-standards.index.31': '状态',
  'auto.pages.pages.projects.estimation-standards.index.32': '启用',
  'auto.pages.pages.projects.estimation-standards.index.33': '禁用',
  'auto.pages.pages.projects.estimation-standards.index.34':
    '项目UUID（空表示全局）',
  'auto.pages.pages.projects.estimation-standards.index.35': '可选',
  'auto.pages.pages.projects.estimation-standards.index.36': '设为默认',
  'auto.pages.pages.projects.index.1': '解析用户信息失败',
  'auto.pages.pages.projects.index.2': '项目列表加载失败',
  'auto.pages.pages.projects.index.3': '项目删除成功',
  'auto.pages.pages.projects.index.4': '项目删除失败',
  'auto.pages.pages.projects.index.5': '项目更新成功',
  'auto.pages.pages.projects.index.6': '项目创建成功',
  'auto.pages.pages.projects.index.7': '编辑',
  'auto.pages.pages.projects.index.8': '确认删除该项目吗？',
  'auto.pages.pages.projects.index.9': '删除',
  'auto.pages.pages.projects.index.10': '取消',
  'auto.pages.pages.projects.index.11': '删除',
  'auto.pages.pages.projects.index.12': '前缀',
  'auto.pages.pages.projects.index.13': '创建 {p1} ｜ 更新 {p2}',
  'auto.pages.pages.projects.index.14': '创建 {p1}',
  'auto.pages.pages.projects.index.15': '更新 {p1}',
  'auto.pages.pages.projects.index.16': '项目管理',
  'auto.pages.pages.projects.index.17': '选择一个项目进入详情工作台',
  'auto.pages.pages.projects.index.18': '搜索项目名称/中文名/标识符',
  'auto.pages.pages.projects.index.19': '刷新',
  'auto.pages.pages.projects.index.20': '新建项目',
  'auto.pages.pages.projects.index.21': '暂无项目数据',
  'auto.pages.pages.projects.index.22': '共 {p1} 个项目',
  'auto.pages.pages.projects.index.23': '编辑项目',
  'auto.pages.pages.projects.index.24': '新建项目',
  'auto.pages.pages.projects.index.25': '项目中文名',
  'auto.pages.pages.projects.index.26': '请输入项目中文名',
  'auto.pages.pages.projects.index.27': '请输入项目中文名',
  'auto.pages.pages.projects.index.28': '项目英文名',
  'auto.pages.pages.projects.index.29': '请输入项目英文名',
  'auto.pages.pages.projects.index.30': '项目标识符',
  'auto.pages.pages.projects.index.31': '请输入项目标识符',
  'auto.pages.pages.projects.index.32': '该标识符已存在',
  'auto.pages.pages.projects.index.33': '例如：PROJ-001',
  'auto.pages.pages.projects.index.34': '项目前缀',
  'auto.pages.pages.projects.index.35': '例如：PROJ',
  'auto.pages.pages.projects.index.36': '项目 Logo',
  'auto.pages.pages.projects.index.37': '请输入 Logo URL',
  'auto.pages.pages.projects.index.38': '项目描述',
  'auto.pages.pages.projects.index.39': '请输入项目描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.1': '未填写',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.2':
    '加载页面设计列表失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.3': '保存成功',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.4': '保存失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.5': '示例项目',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.6':
    '一个现代化的项目管理平台',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.7':
    'AI 已识别 {p1} 个功能点，并建议了 {p2} 个页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.8':
    '生成页面建议失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.9':
    '页面组件方案生成完成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.10':
    '页面组件方案生成失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.11':
    '分析结果已保存',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.12': '包含：{p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.13':
    '应用分析结果失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.14':
    '获取组件详情失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.15':
    '请先分析该页面的组件方案，再查看草图',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.16':
    '生成原型草图失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.17': '删除成功',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.18': '删除失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.19':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.20': '页面设计',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.21':
    '页面设计导出_{p1}.xlsx',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.22':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.23':
    '# 页面设计导出\n\n| 页面名称 | 页面描述 | 核心组件概括 |\n| --- | --- | --- |\n',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.24':
    '页面设计导出_{p1}.md',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.25':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.26':
    '页面设计方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.27': '页面设计',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.28': '核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.29': '核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.30':
    '页面设计导出_{p1}.xmind',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.31':
    '导出 XMind 失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.32': '导出 Excel',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.33':
    '导出 Markdown',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.34': '导出 XMind',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.35': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.36': '页面描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.37':
    '核心组件概括',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.38': '未分析',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.39': '操作',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.40': '分析组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.41': '查看草图',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.42': '编辑',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.43':
    '确定删除吗？',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.44': '删除',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.45':
    'AI 生成页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.46': '手工添加',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.47':
    '保存当前列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.48': '批量导出',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.49': '清空列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.50':
    'AI 辅助设计方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.51':
    '确认并保存到项目',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.52': '需求场景',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.53': '项目名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.54':
    '输入项目名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.55': '项目描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.56':
    '描述核心功能、目标用户...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.57':
    '建议页面数量',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.58':
    'AI 补充指令',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.59':
    '例如：偏重移动端、采用极简风格、需要深色模式建议...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.60':
    '开始 AI 生成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.61':
    '建议页面列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.62': '页面名',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.63': '描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.64':
    '点击左侧开始生成页面方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.65':
    'AI 页面组件分析',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.66': '关闭',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.67':
    '应用并保存结果',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.68': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.69':
    '补充分析需求',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.70':
    '例如：分析需要包含哪些具体交互逻辑...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.71':
    '一键分析核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.72': '组件名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.73': '组件类型',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.74': '功能描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.75':
    '页面组件详情 - {p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.76': '名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.77': '类型',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.78': '描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.79':
    '页面原型草图 - {p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.80': '关闭',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.81':
    '代码已复制到剪贴板',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.82': '复制代码',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.83':
    'AI 正在极速生成原型草图代码...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.84':
    '未能生成有效代码',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.85': '编辑页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.86': '新增页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.87': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.88': '页面描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.89': '组件概要',
  'auto.pages.pages.prototype-design.index.1': '项目列表页',
  'auto.pages.pages.prototype-design.index.2': '项目详情页',
  'auto.pages.pages.prototype-design.index.3': '需求文档页',
  'auto.pages.pages.prototype-design.index.4': '页面',
  'auto.pages.pages.prototype-design.index.5': '版本',
  'auto.pages.pages.prototype-design.index.6': '设计师',
  'auto.pages.pages.prototype-design.index.7': '评审时间',
  'auto.pages.pages.prototype-design.index.8': '状态',
  'auto.pages.pages.prototype-design.index.9': '草稿',
  'auto.pages.pages.prototype-design.index.10': '评审中',
  'auto.pages.pages.prototype-design.index.11': '已通过',
  'auto.pages.pages.prototype-design.index.12': '操作',
  'auto.pages.pages.prototype-design.index.13': '查看',
  'auto.pages.pages.prototype-design.index.14': '历史版本',
  'auto.pages.pages.prototype-design.index.15': '页面设计',
  'auto.pages.pages.prototype-design.index.16': '管理原型版本、评审与变更记录',
  'auto.pages.pages.prototype-design.index.17': '新建原型',
  'auto.pages.pages.prototype-design.index.18': '同步设计平台',
  'auto.pages.pages.prototype-design.theme-design.index.1': '主色',
  'auto.pages.pages.prototype-design.theme-design.index.2': '成功色',
  'auto.pages.pages.prototype-design.theme-design.index.3': '警告色',
  'auto.pages.pages.prototype-design.theme-design.index.4': '错误色',
  'auto.pages.pages.prototype-design.theme-design.index.5': '圆角',
  'auto.pages.pages.prototype-design.theme-design.index.6': '基础字号',
  'auto.pages.pages.prototype-design.theme-design.index.7': '字体',
  'auto.pages.pages.prototype-design.theme-design.index.8': '紧凑模式',
  'auto.pages.pages.prototype-design.theme-design.index.9': '启用阴影',
  'auto.pages.pages.prototype-design.theme-design.index.10':
    'Ant Design 主题配置已保存（示例）',
  'auto.pages.pages.prototype-design.theme-design.index.11': '保存主题',
  'auto.pages.pages.prototype-design.theme-design.index.12': '重置',
  'auto.pages.pages.prototype-design.theme-design.index.13': '实时预览',
  'auto.pages.pages.prototype-design.theme-design.index.14': '项目管理工作台',
  'auto.pages.pages.prototype-design.theme-design.index.15':
    '基于 Token 的主题展示，支持主色、字号、圆角与阴影开关。',
  'auto.pages.pages.prototype-design.theme-design.index.16':
    'Element Plus 变量',
  'auto.pages.pages.prototype-design.theme-design.index.17':
    '主色 --el-color-primary',
  'auto.pages.pages.prototype-design.theme-design.index.18':
    '成功色 --el-color-success',
  'auto.pages.pages.prototype-design.theme-design.index.19':
    '警告色 --el-color-warning',
  'auto.pages.pages.prototype-design.theme-design.index.20':
    '危险色 --el-color-danger',
  'auto.pages.pages.prototype-design.theme-design.index.21':
    '信息色 --el-color-info',
  'auto.pages.pages.prototype-design.theme-design.index.22':
    '圆角 --el-border-radius-base',
  'auto.pages.pages.prototype-design.theme-design.index.23':
    '字体 --el-font-family',
  'auto.pages.pages.prototype-design.theme-design.index.24': '深色菜单',
  'auto.pages.pages.prototype-design.theme-design.index.25':
    'Element Plus 主题配置已保存（示例）',
  'auto.pages.pages.prototype-design.theme-design.index.26': '保存主题',
  'auto.pages.pages.prototype-design.theme-design.index.27': '实时预览',
  'auto.pages.pages.prototype-design.theme-design.index.28':
    '使用 CSS 变量映射 Element Plus\n              主题：`--el-color-primary`、`--el-font-family` 等。',
  'auto.pages.pages.prototype-design.theme-design.index.29': '主题设计',
  'auto.pages.pages.prototype-design.theme-design.index.30':
    '辅助设计系统主题（颜色、字体、圆角等），提供 Ant Design 与 Element Plus 两套配置',
  'auto.pages.pages.prototype-design.theme-design.index.31':
    'Ant Design 主题编辑器',
  'auto.pages.pages.quality-management.index.1': '代码规范符合率',
  'auto.pages.pages.quality-management.index.2': '前端组',
  'auto.pages.pages.quality-management.index.3': '需求缺陷逃逸率',
  'auto.pages.pages.quality-management.index.4': '产品组',
  'auto.pages.pages.quality-management.index.5': '自动化测试覆盖率',
  'auto.pages.pages.quality-management.index.6': '测试组',
  'auto.pages.pages.quality-management.index.7': '指标',
  'auto.pages.pages.quality-management.index.8': '责任团队',
  'auto.pages.pages.quality-management.index.9': '得分',
  'auto.pages.pages.quality-management.index.10': '更新时间',
  'auto.pages.pages.quality-management.index.11': '趋势',
  'auto.pages.pages.quality-management.index.12': '上升',
  'auto.pages.pages.quality-management.index.13': '下降',
  'auto.pages.pages.quality-management.index.14': '持平',
  'auto.pages.pages.quality-management.index.15': '质量管理',
  'auto.pages.pages.quality-management.index.16':
    '质量度量、检查结果与持续改进闭环',
  'auto.pages.pages.quality-management.index.17': '综合质量分',
  'auto.pages.pages.quality-management.index.18': '本周新增问题',
  'auto.pages.pages.quality-management.index.19': '已关闭问题',
  'auto.pages.pages.quote-management.index.1': '华东零售集团',
  'auto.pages.pages.quote-management.index.2': '北方制造有限公司',
  'auto.pages.pages.quote-management.index.3': '华南物流科技',
  'auto.pages.pages.quote-management.index.4': '报价单号',
  'auto.pages.pages.quote-management.index.5': '客户名称',
  'auto.pages.pages.quote-management.index.6': '报价金额',
  'auto.pages.pages.quote-management.index.7': '版本',
  'auto.pages.pages.quote-management.index.8': '状态',
  'auto.pages.pages.quote-management.index.9': '草稿',
  'auto.pages.pages.quote-management.index.10': '已提交',
  'auto.pages.pages.quote-management.index.11': '已确认',
  'auto.pages.pages.quote-management.index.12': '更新时间',
  'auto.pages.pages.quote-management.index.13': '报价管理',
  'auto.pages.pages.quote-management.index.14':
    '生成报价单并跟踪报价版本与状态',
  'auto.pages.pages.quote-management.index.15': '本月报价单',
  'auto.pages.pages.quote-management.index.16': '待确认报价',
  'auto.pages.pages.quote-management.index.17': '报价转化率',
  'auto.pages.pages.quote-management.index.18': 'Channel Expansion',
  'auto.pages.pages.quote-management.index.19': 'Key Account Push',
  'auto.pages.pages.quote-management.index.20': 'Existing Customer Renewal',
  'auto.pages.pages.quote-management.index.21': 'Initial Contact',
  'auto.pages.pages.quote-management.index.22': 'Solution Review',
  'auto.pages.pages.quote-management.index.23': 'Commercial Negotiation',
  'auto.pages.pages.quote-management.index.24': 'Pipeline',
  'auto.pages.pages.quote-management.index.25': 'Stage',
  'auto.pages.pages.requirements.application-analysis.index.1': 'Web端',
  'auto.pages.pages.requirements.application-analysis.index.2': 'iOS端',
  'auto.pages.pages.requirements.application-analysis.index.3': '安卓端',
  'auto.pages.pages.requirements.application-analysis.index.4': '小程序端',
  'auto.pages.pages.requirements.application-analysis.index.5': '桌面端',
  'auto.pages.pages.requirements.application-analysis.index.6': '嵌入式端',
  'auto.pages.pages.requirements.application-analysis.index.7': '车载端',
  'auto.pages.pages.requirements.application-analysis.index.8': 'TV端',
  'auto.pages.pages.requirements.application-analysis.index.9': 'IoT端',
  'auto.pages.pages.requirements.application-analysis.index.10': '开放API端',
  'auto.pages.pages.requirements.application-analysis.index.11': '其他',
  'auto.pages.pages.requirements.application-analysis.index.12': '未命名项目',
  'auto.pages.pages.requirements.application-analysis.index.13':
    '加载应用分析失败',
  'auto.pages.pages.requirements.application-analysis.index.14':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.application-analysis.index.15':
    '项目信息已保存',
  'auto.pages.pages.requirements.application-analysis.index.16':
    '保存项目信息失败',
  'auto.pages.pages.requirements.application-analysis.index.17':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.application-analysis.index.18':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.requirements.application-analysis.index.19': 'AI 生成失败',
  'auto.pages.pages.requirements.application-analysis.index.20':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.application-analysis.index.21':
    '请先勾选预览端',
  'auto.pages.pages.requirements.application-analysis.index.22':
    '已添加并保存 {p1} 个端',
  'auto.pages.pages.requirements.application-analysis.index.23': '添加失败',
  'auto.pages.pages.requirements.application-analysis.index.24':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.application-analysis.index.25': '保存成功',
  'auto.pages.pages.requirements.application-analysis.index.26': '保存失败',
  'auto.pages.pages.requirements.application-analysis.index.27':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.application-analysis.index.28':
    '已清空应用端分析数据',
  'auto.pages.pages.requirements.application-analysis.index.29': '清空失败',
  'auto.pages.pages.requirements.application-analysis.index.30': '未填写',
  'auto.pages.pages.requirements.application-analysis.index.31': '端名称',
  'auto.pages.pages.requirements.application-analysis.index.32': '未填写',
  'auto.pages.pages.requirements.application-analysis.index.33': '端类型',
  'auto.pages.pages.requirements.application-analysis.index.34': '未填写',
  'auto.pages.pages.requirements.application-analysis.index.35': '英文名',
  'auto.pages.pages.requirements.application-analysis.index.36': '缩写',
  'auto.pages.pages.requirements.application-analysis.index.37': '目标用户',
  'auto.pages.pages.requirements.application-analysis.index.38': '核心场景',
  'auto.pages.pages.requirements.application-analysis.index.39': '核心能力',
  'auto.pages.pages.requirements.application-analysis.index.40': '运行环境',
  'auto.pages.pages.requirements.application-analysis.index.41': '交互方式',
  'auto.pages.pages.requirements.application-analysis.index.42': '集成依赖',
  'auto.pages.pages.requirements.application-analysis.index.43': '非功能要求',
  'auto.pages.pages.requirements.application-analysis.index.44': '优先级',
  'auto.pages.pages.requirements.application-analysis.index.45': '阶段',
  'auto.pages.pages.requirements.application-analysis.index.46': '状态',
  'auto.pages.pages.requirements.application-analysis.index.47': '操作',
  'auto.pages.pages.requirements.application-analysis.index.48': '编辑',
  'auto.pages.pages.requirements.application-analysis.index.49': '删除',
  'auto.pages.pages.requirements.application-analysis.index.50': '端名称',
  'auto.pages.pages.requirements.application-analysis.index.51': '未填写',
  'auto.pages.pages.requirements.application-analysis.index.52': '端类型',
  'auto.pages.pages.requirements.application-analysis.index.53': '未填写',
  'auto.pages.pages.requirements.application-analysis.index.54': '目标用户',
  'auto.pages.pages.requirements.application-analysis.index.55': '核心场景',
  'auto.pages.pages.requirements.application-analysis.index.56': '核心能力',
  'auto.pages.pages.requirements.application-analysis.index.57': '优先级',
  'auto.pages.pages.requirements.application-analysis.index.58': '阶段',
  'auto.pages.pages.requirements.application-analysis.index.59': '应用分析',
  'auto.pages.pages.requirements.application-analysis.index.60':
    '基于项目“{p1}”识别应建设的端（Web/移动/车载/嵌入式等）',
  'auto.pages.pages.requirements.application-analysis.index.61': 'AI应用分析',
  'auto.pages.pages.requirements.application-analysis.index.62': '新增端',
  'auto.pages.pages.requirements.application-analysis.index.63': '保存',
  'auto.pages.pages.requirements.application-analysis.index.64':
    '确认清空当前项目应用端分析数据？',
  'auto.pages.pages.requirements.application-analysis.index.65': '清空重置',
  'auto.pages.pages.requirements.application-analysis.index.66': '删除选中（',
  'auto.pages.pages.requirements.application-analysis.index.67':
    '暂无应用端分析数据，点击“AI应用分析”或“新增端”开始',
  'auto.pages.pages.requirements.application-analysis.index.68': '编辑应用端',
  'auto.pages.pages.requirements.application-analysis.index.69': '新增应用端',
  'auto.pages.pages.requirements.application-analysis.index.70': '确定',
  'auto.pages.pages.requirements.application-analysis.index.71': '取消',
  'auto.pages.pages.requirements.application-analysis.index.72':
    '端名称（中文）',
  'auto.pages.pages.requirements.application-analysis.index.73': '请输入端名称',
  'auto.pages.pages.requirements.application-analysis.index.74':
    '例如：Web管理端、iOS移动端、车载端',
  'auto.pages.pages.requirements.application-analysis.index.75': '端类型',
  'auto.pages.pages.requirements.application-analysis.index.76': '请选择端类型',
  'auto.pages.pages.requirements.application-analysis.index.77': '发布优先级',
  'auto.pages.pages.requirements.application-analysis.index.78':
    '端名称（英文）',
  'auto.pages.pages.requirements.application-analysis.index.79':
    '例如：Web Admin Console',
  'auto.pages.pages.requirements.application-analysis.index.80': '端简称',
  'auto.pages.pages.requirements.application-analysis.index.81': '例如：WAC',
  'auto.pages.pages.requirements.application-analysis.index.82': '目标用户',
  'auto.pages.pages.requirements.application-analysis.index.83': '核心场景',
  'auto.pages.pages.requirements.application-analysis.index.84': '核心能力',
  'auto.pages.pages.requirements.application-analysis.index.85':
    '运行环境/平台约束',
  'auto.pages.pages.requirements.application-analysis.index.86': '交互方式',
  'auto.pages.pages.requirements.application-analysis.index.87': '集成依赖',
  'auto.pages.pages.requirements.application-analysis.index.88': '非功能要求',
  'auto.pages.pages.requirements.application-analysis.index.89': '发布阶段',
  'auto.pages.pages.requirements.application-analysis.index.90':
    '例如：MVP、Phase-2',
  'auto.pages.pages.requirements.application-analysis.index.91': '状态',
  'auto.pages.pages.requirements.application-analysis.index.92': 'AI 应用分析',
  'auto.pages.pages.requirements.application-analysis.index.93': '生成选项',
  'auto.pages.pages.requirements.application-analysis.index.94': '项目名称',
  'auto.pages.pages.requirements.application-analysis.index.95':
    '请输入项目名称',
  'auto.pages.pages.requirements.application-analysis.index.96':
    '请输入项目名称',
  'auto.pages.pages.requirements.application-analysis.index.97': '项目简介',
  'auto.pages.pages.requirements.application-analysis.index.98':
    '请输入项目简介',
  'auto.pages.pages.requirements.application-analysis.index.99':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.requirements.application-analysis.index.100':
    '例如：重点考虑外勤、供应链、车载设备和管理后台等多端协同场景',
  'auto.pages.pages.requirements.application-analysis.index.101': '拆解端数量',
  'auto.pages.pages.requirements.application-analysis.index.102':
    '请输入拆解数量',
  'auto.pages.pages.requirements.application-analysis.index.103':
    '数量范围为 1-20',
  'auto.pages.pages.requirements.application-analysis.index.104':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.requirements.application-analysis.index.105':
    '保存项目信息',
  'auto.pages.pages.requirements.application-analysis.index.106': '取消',
  'auto.pages.pages.requirements.application-analysis.index.107': '生成预览',
  'auto.pages.pages.requirements.application-analysis.index.108': '预览结果',
  'auto.pages.pages.requirements.application-analysis.index.109':
    '勾选需要的端后添加到列表',
  'auto.pages.pages.requirements.application-analysis.index.110':
    '点击“生成预览”后查看候选端',
  'auto.pages.pages.requirements.application-analysis.index.111':
    '重名时覆盖已有端',
  'auto.pages.pages.requirements.application-analysis.index.112':
    '添加选中到端列表（',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.1': '项目',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.2':
    '承载需求、应用与交付活动的业务单元',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.3': '应用',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.4':
    '项目下可独立管理与发布的功能系统',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.5': '需求条目',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.6':
    '可被追踪和验收的具体业务需求',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.7': '概念分析',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.8':
    '统一核心术语定义，降低沟通歧义',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.9': '概念',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.10': '定义',
  'auto.pages.pages.requirements.concept-analysis.index.1': '未命名项目',
  'auto.pages.pages.requirements.concept-analysis.index.2': '加载概念分析失败',
  'auto.pages.pages.requirements.concept-analysis.index.3':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.concept-analysis.index.4': '项目信息已保存',
  'auto.pages.pages.requirements.concept-analysis.index.5': '保存项目信息失败',
  'auto.pages.pages.requirements.concept-analysis.index.6':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.concept-analysis.index.7':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.requirements.concept-analysis.index.8': 'AI 生成失败',
  'auto.pages.pages.requirements.concept-analysis.index.9':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.concept-analysis.index.10': '请先勾选预览概念',
  'auto.pages.pages.requirements.concept-analysis.index.11':
    '已添加并保存 {p1} 个概念',
  'auto.pages.pages.requirements.concept-analysis.index.12': '添加失败',
  'auto.pages.pages.requirements.concept-analysis.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.concept-analysis.index.14': '保存成功',
  'auto.pages.pages.requirements.concept-analysis.index.15': '保存失败',
  'auto.pages.pages.requirements.concept-analysis.index.16':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.concept-analysis.index.17': '已清空概念数据',
  'auto.pages.pages.requirements.concept-analysis.index.18': '清空失败',
  'auto.pages.pages.requirements.concept-analysis.index.19': '未填写',
  'auto.pages.pages.requirements.concept-analysis.index.20': '概念中文名',
  'auto.pages.pages.requirements.concept-analysis.index.21': '未填写',
  'auto.pages.pages.requirements.concept-analysis.index.22': '概念英文名',
  'auto.pages.pages.requirements.concept-analysis.index.23': '缩写',
  'auto.pages.pages.requirements.concept-analysis.index.24': '释义',
  'auto.pages.pages.requirements.concept-analysis.index.25': '同义词',
  'auto.pages.pages.requirements.concept-analysis.index.26': '关联功能范围',
  'auto.pages.pages.requirements.concept-analysis.index.27': '边界说明',
  'auto.pages.pages.requirements.concept-analysis.index.28': '示例',
  'auto.pages.pages.requirements.concept-analysis.index.29': '上位概念',
  'auto.pages.pages.requirements.concept-analysis.index.30': '下位概念',
  'auto.pages.pages.requirements.concept-analysis.index.31': '状态',
  'auto.pages.pages.requirements.concept-analysis.index.32': '操作',
  'auto.pages.pages.requirements.concept-analysis.index.33': '编辑',
  'auto.pages.pages.requirements.concept-analysis.index.34': '删除',
  'auto.pages.pages.requirements.concept-analysis.index.35': '概念中文名',
  'auto.pages.pages.requirements.concept-analysis.index.36': '未填写',
  'auto.pages.pages.requirements.concept-analysis.index.37': '概念英文名',
  'auto.pages.pages.requirements.concept-analysis.index.38': '缩写',
  'auto.pages.pages.requirements.concept-analysis.index.39': '释义',
  'auto.pages.pages.requirements.concept-analysis.index.40': '同义词',
  'auto.pages.pages.requirements.concept-analysis.index.41': '关联功能范围',
  'auto.pages.pages.requirements.concept-analysis.index.42': '边界说明',
  'auto.pages.pages.requirements.concept-analysis.index.43': '概念分析',
  'auto.pages.pages.requirements.concept-analysis.index.44':
    '基于项目“{p1}”自动提炼并维护统一术语概念',
  'auto.pages.pages.requirements.concept-analysis.index.45': 'AI概念分析',
  'auto.pages.pages.requirements.concept-analysis.index.46': '新增概念',
  'auto.pages.pages.requirements.concept-analysis.index.47': '保存',
  'auto.pages.pages.requirements.concept-analysis.index.48':
    '确认清空当前项目概念数据？',
  'auto.pages.pages.requirements.concept-analysis.index.49': '清空重置',
  'auto.pages.pages.requirements.concept-analysis.index.50': '删除选中（',
  'auto.pages.pages.requirements.concept-analysis.index.51':
    '暂无概念分析数据，点击“AI概念分析”或“新增概念”开始',
  'auto.pages.pages.requirements.concept-analysis.index.52': '编辑概念',
  'auto.pages.pages.requirements.concept-analysis.index.53': '新增概念',
  'auto.pages.pages.requirements.concept-analysis.index.54': '确定',
  'auto.pages.pages.requirements.concept-analysis.index.55': '取消',
  'auto.pages.pages.requirements.concept-analysis.index.56': '概念中文名',
  'auto.pages.pages.requirements.concept-analysis.index.57': '请输入概念中文名',
  'auto.pages.pages.requirements.concept-analysis.index.58': '例如：需求条目',
  'auto.pages.pages.requirements.concept-analysis.index.59': '概念英文名',
  'auto.pages.pages.requirements.concept-analysis.index.60':
    '例如：Requirement Item',
  'auto.pages.pages.requirements.concept-analysis.index.61': '缩写',
  'auto.pages.pages.requirements.concept-analysis.index.62': '例如：RI',
  'auto.pages.pages.requirements.concept-analysis.index.63': '释义',
  'auto.pages.pages.requirements.concept-analysis.index.64': '请输入概念释义',
  'auto.pages.pages.requirements.concept-analysis.index.65':
    '同义词（逗号分隔）',
  'auto.pages.pages.requirements.concept-analysis.index.66': '关联功能范围',
  'auto.pages.pages.requirements.concept-analysis.index.67': '边界说明',
  'auto.pages.pages.requirements.concept-analysis.index.68': '示例',
  'auto.pages.pages.requirements.concept-analysis.index.69': '上位概念',
  'auto.pages.pages.requirements.concept-analysis.index.70':
    '下位概念（逗号分隔）',
  'auto.pages.pages.requirements.concept-analysis.index.71': '状态',
  'auto.pages.pages.requirements.concept-analysis.index.72': 'AI 概念分析',
  'auto.pages.pages.requirements.concept-analysis.index.73': '生成选项',
  'auto.pages.pages.requirements.concept-analysis.index.74': '项目名称',
  'auto.pages.pages.requirements.concept-analysis.index.75': '请输入项目名称',
  'auto.pages.pages.requirements.concept-analysis.index.76': '请输入项目名称',
  'auto.pages.pages.requirements.concept-analysis.index.77': '项目简介',
  'auto.pages.pages.requirements.concept-analysis.index.78': '请输入项目简介',
  'auto.pages.pages.requirements.concept-analysis.index.79':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.requirements.concept-analysis.index.80':
    '例如：请重点输出业务术语边界、同义词和常见混淆点',
  'auto.pages.pages.requirements.concept-analysis.index.81': '拆解概念数量',
  'auto.pages.pages.requirements.concept-analysis.index.82': '请输入拆解数量',
  'auto.pages.pages.requirements.concept-analysis.index.83': '数量范围为 1-50',
  'auto.pages.pages.requirements.concept-analysis.index.84':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.requirements.concept-analysis.index.85': '保存项目信息',
  'auto.pages.pages.requirements.concept-analysis.index.86': '取消',
  'auto.pages.pages.requirements.concept-analysis.index.87': '生成预览',
  'auto.pages.pages.requirements.concept-analysis.index.88': '预览结果',
  'auto.pages.pages.requirements.concept-analysis.index.89':
    '勾选需要的概念后添加到列表',
  'auto.pages.pages.requirements.concept-analysis.index.90':
    '点击“生成预览”后查看候选概念',
  'auto.pages.pages.requirements.concept-analysis.index.91':
    '重名时覆盖已有概念',
  'auto.pages.pages.requirements.concept-analysis.index.92':
    '添加选中到概念列表（',
  'auto.pages.pages.requirements.document.index.1': '需求文档',
  'auto.pages.pages.requirements.document.index.2': '面向客户的标准版需求文档',
  'auto.pages.pages.requirements.document.index.3': '文档概览',
  'auto.pages.pages.requirements.document.index.4': '空白项目111',
  'auto.pages.pages.requirements.document.index.5': '产品负责人',
  'auto.pages.pages.requirements.document.index.6': '客户代表',
  'auto.pages.pages.requirements.document.index.7': '评审中',
  'auto.pages.pages.requirements.document.index.8': '文档编号',
  'auto.pages.pages.requirements.document.index.9': '所属项目',
  'auto.pages.pages.requirements.document.index.10': '负责人',
  'auto.pages.pages.requirements.document.index.11': '评审人',
  'auto.pages.pages.requirements.document.index.12': '版本',
  'auto.pages.pages.requirements.document.index.13': '状态',
  'auto.pages.pages.requirements.document.index.14': '评审中',
  'auto.pages.pages.requirements.document.index.15': '文档交付流程',
  'auto.pages.pages.requirements.document.index.16': '需求确认',
  'auto.pages.pages.requirements.document.index.17': '确认结论',
  'auto.pages.pages.requirements.document.index.18': '已完成需求范围确认',
  'auto.pages.pages.requirements.document.index.19': '客户评审',
  'auto.pages.pages.requirements.document.index.20': '评审意见',
  'auto.pages.pages.requirements.document.index.21': '需补充数据字典章节',
  'auto.pages.pages.requirements.document.index.22': '交付归档',
  'auto.pages.pages.requirements.document.index.23': '归档编号',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.1':
    '加载思维导图数据失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.2':
    '加载思维导图数据失败',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.3':
    '功能需求',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.4':
    '标题不能为空',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.5':
    '节点已更新',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.6':
    '更新节点失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.7':
    '更新节点失败',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.8':
    '一键展开',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.9':
    '一键折叠',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.10':
    '编辑节点',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.11':
    '标题',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.12':
    '请输入标题',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.13':
    '请输入节点标题',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.14':
    '描述',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.15':
    '请输入节点描述',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.1':
    '已完成',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.2':
    '进行中',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.3':
    '草稿',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.4':
    '加载表格数据失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.5':
    '加载表格数据失败',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.6':
    '加载功能点类型失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.7':
    '加载估算标准参数失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.8':
    '模块',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.9':
    '功能',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.10':
    '功能点',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.11':
    '功能点类型',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.12':
    '功能点复杂度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.13':
    '预估工时',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.14':
    '描述',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.15':
    '状态',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.16':
    '草稿',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.17':
    '进行中',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.18':
    '已确认',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.19':
    '已完成',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.20':
    '状态仅支持：草稿/进行中/已完成（或 0/1/2）',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.21':
    '仅功能点支持编辑预估工时',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.22':
    '预估工时必须为非负数字',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.23':
    '保存失败 {p1} 项',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.24':
    '单元格内容已保存',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.25':
    '仅功能点支持编辑功能点类型与复杂度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.26':
    '已更新',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.27':
    '更新失败',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.28':
    '标题不能为空',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.29':
    '请先选中一行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.30':
    '新行已插入并保存',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.31':
    '插入新行失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.32':
    '插入新行失败',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.33':
    '请先选中一行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.34':
    '未找到选中项',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.35':
    '确认删除',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.36':
    '确定删除“{p1}”吗？',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.37':
    '删除成功',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.38':
    '请先选中一行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.39':
    '未找到选中项',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.40':
    '{p1}（副本）',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.41':
    '复制成功',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.42':
    '复制失败:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.43':
    '复制失败',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.44':
    '新增模块行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.45':
    '选中项下方插入同级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.46':
    '选中项下新增子级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.47':
    '复制行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.48':
    '删除行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.49':
    '正在加载表格数据...',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.50':
    '当前暂无需求数据',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.51':
    '复制行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.52':
    '删除行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.53':
    '拖拽调整表格高度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.54':
    '新增模块行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.55':
    '在选中项下方插入同级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.56':
    '在选中项下新增子级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.57':
    '标题',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.58':
    '请输入标题',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.59':
    '请输入需求项标题',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.60':
    '描述',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.61':
    '请输入需求项描述',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.62':
    '编辑功能点类型',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.63':
    '编辑复杂度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.64':
    '请选择功能点类型',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.65':
    '请选择复杂度',
  'auto.pages.pages.requirements.feature-list.index.1': '已完成',
  'auto.pages.pages.requirements.feature-list.index.2': '进行中',
  'auto.pages.pages.requirements.feature-list.index.3': '草稿',
  'auto.pages.pages.requirements.feature-list.index.4': '模块',
  'auto.pages.pages.requirements.feature-list.index.5': '子模块',
  'auto.pages.pages.requirements.feature-list.index.6': '功能',
  'auto.pages.pages.requirements.feature-list.index.7': '子功能',
  'auto.pages.pages.requirements.feature-list.index.8': '功能点',
  'auto.pages.pages.requirements.feature-list.index.9': '任务',
  'auto.pages.pages.requirements.feature-list.index.10': '按需要',
  'auto.pages.pages.requirements.feature-list.index.11': '按标题',
  'auto.pages.pages.requirements.feature-list.index.12': '按添加时间',
  'auto.pages.pages.requirements.feature-list.index.13': '按修改时间',
  'auto.pages.pages.requirements.feature-list.index.14': '升序',
  'auto.pages.pages.requirements.feature-list.index.15': '降序',
  'auto.pages.pages.requirements.feature-list.index.16': '项目',
  'auto.pages.pages.requirements.feature-list.index.17': '模块',
  'auto.pages.pages.requirements.feature-list.index.18': '一级模块',
  'auto.pages.pages.requirements.feature-list.index.19': '模块名称',
  'auto.pages.pages.requirements.feature-list.index.20': '功能',
  'auto.pages.pages.requirements.feature-list.index.21': '二级功能',
  'auto.pages.pages.requirements.feature-list.index.22': '功能名称',
  'auto.pages.pages.requirements.feature-list.index.23': '功能点',
  'auto.pages.pages.requirements.feature-list.index.24': '三级功能点',
  'auto.pages.pages.requirements.feature-list.index.25': '功能点名称',
  'auto.pages.pages.requirements.feature-list.index.26': '模块描述',
  'auto.pages.pages.requirements.feature-list.index.27': '一级模块描述',
  'auto.pages.pages.requirements.feature-list.index.28': '功能描述',
  'auto.pages.pages.requirements.feature-list.index.29': '二级功能描述',
  'auto.pages.pages.requirements.feature-list.index.30': '功能点描述',
  'auto.pages.pages.requirements.feature-list.index.31': '三级功能点描述',
  'auto.pages.pages.requirements.feature-list.index.32': '描述',
  'auto.pages.pages.requirements.feature-list.index.33': '说明',
  'auto.pages.pages.requirements.feature-list.index.34': '功能需求',
  'auto.pages.pages.requirements.feature-list.index.35':
    '加载功能点类型字典失败:',
  'auto.pages.pages.requirements.feature-list.index.36': '加载估算标准失败:',
  'auto.pages.pages.requirements.feature-list.index.37': '请先选择估算标准',
  'auto.pages.pages.requirements.feature-list.index.38':
    '将评估该项下功能点的工时，仅做工时评估，不会进行功能拆解',
  'auto.pages.pages.requirements.feature-list.index.39':
    '已评估下级功能点工时：成功 {p1}，失败 {p2}，跳过 {p3}',
  'auto.pages.pages.requirements.feature-list.index.40': '下级功能点评估失败:',
  'auto.pages.pages.requirements.feature-list.index.41': '下级功能点评估失败',
  'auto.pages.pages.requirements.feature-list.index.42':
    '仅功能点支持单项工时评估',
  'auto.pages.pages.requirements.feature-list.index.43':
    '已评估：{p1} = {p2}h（{p3} / L{p4}）',
  'auto.pages.pages.requirements.feature-list.index.44': '该项已跳过',
  'auto.pages.pages.requirements.feature-list.index.45': '该项评估失败',
  'auto.pages.pages.requirements.feature-list.index.46': '单项工时评估失败:',
  'auto.pages.pages.requirements.feature-list.index.47': '单项工时评估失败',
  'auto.pages.pages.requirements.feature-list.index.48': '请先创建需求清单',
  'auto.pages.pages.requirements.feature-list.index.49': '请先选择估算标准',
  'auto.pages.pages.requirements.feature-list.index.50':
    '请先在页面中选择一个模块',
  'auto.pages.pages.requirements.feature-list.index.51':
    '请先在页面中选择一个功能',
  'auto.pages.pages.requirements.feature-list.index.52': '正在准备评估...',
  'auto.pages.pages.requirements.feature-list.index.53': '正在评估中...',
  'auto.pages.pages.requirements.feature-list.index.54': '没有可评估的功能点',
  'auto.pages.pages.requirements.feature-list.index.55':
    '预统计批量评估候选项失败:',
  'auto.pages.pages.requirements.feature-list.index.56':
    '批量评估完成：成功 {p1}，失败 {p2}，跳过 {p3}',
  'auto.pages.pages.requirements.feature-list.index.57': '加载统计数据失败:',
  'auto.pages.pages.requirements.feature-list.index.58': '加载项目详情失败:',
  'auto.pages.pages.requirements.feature-list.index.59':
    '读取指定需求清单失败:',
  'auto.pages.pages.requirements.feature-list.index.60':
    'URL指定需求清单不存在或不可用:',
  'auto.pages.pages.requirements.feature-list.index.61': '加载功能清单失败:',
  'auto.pages.pages.requirements.feature-list.index.62': '加载功能清单失败',
  'auto.pages.pages.requirements.feature-list.index.63': ' [默认]',
  'auto.pages.pages.requirements.feature-list.index.64':
    '缺少项目ID，无法创建清单',
  'auto.pages.pages.requirements.feature-list.index.65': '项目',
  'auto.pages.pages.requirements.feature-list.index.66': '请先选择清单',
  'auto.pages.pages.requirements.feature-list.index.67':
    '缺少项目ID，无法保存清单',
  'auto.pages.pages.requirements.feature-list.index.68': '请先选择清单',
  'auto.pages.pages.requirements.feature-list.index.69':
    '请填写完整清单名称和版本号',
  'auto.pages.pages.requirements.feature-list.index.70': '清单创建成功',
  'auto.pages.pages.requirements.feature-list.index.71': '清单更新成功',
  'auto.pages.pages.requirements.feature-list.index.72': '保存需求清单失败:',
  'auto.pages.pages.requirements.feature-list.index.73': '保存需求清单失败',
  'auto.pages.pages.requirements.feature-list.index.74': '切换需求清单失败:',
  'auto.pages.pages.requirements.feature-list.index.75': '切换需求清单失败',
  'auto.pages.pages.requirements.feature-list.index.76': '当前清单已是默认清单',
  'auto.pages.pages.requirements.feature-list.index.77': '已设置为默认清单',
  'auto.pages.pages.requirements.feature-list.index.78': '设置默认清单失败:',
  'auto.pages.pages.requirements.feature-list.index.79': '设置默认清单失败',
  'auto.pages.pages.requirements.feature-list.index.80':
    '默认清单不允许删除，请先切换其它清单为默认',
  'auto.pages.pages.requirements.feature-list.index.81': '清单删除成功',
  'auto.pages.pages.requirements.feature-list.index.82': '删除清单失败:',
  'auto.pages.pages.requirements.feature-list.index.83': '删除清单失败',
  'auto.pages.pages.requirements.feature-list.index.84': '加载功能列表失败:',
  'auto.pages.pages.requirements.feature-list.index.85': '加载功能列表失败',
  'auto.pages.pages.requirements.feature-list.index.86': '加载功能点列表失败:',
  'auto.pages.pages.requirements.feature-list.index.87': '加载功能点列表失败',
  'auto.pages.pages.requirements.feature-list.index.88': '请先创建需求清单',
  'auto.pages.pages.requirements.feature-list.index.89':
    '清空完成：删除 {p1} 项',
  'auto.pages.pages.requirements.feature-list.index.90': '按范围清空失败:',
  'auto.pages.pages.requirements.feature-list.index.91': '清空失败',
  'auto.pages.pages.requirements.feature-list.index.92':
    '将删除范围内所有需求项及其下级，删除后不可恢复。',
  'auto.pages.pages.requirements.feature-list.index.93': '清空',
  'auto.pages.pages.requirements.feature-list.index.94': '取消',
  'auto.pages.pages.requirements.feature-list.index.95': '缺少项目信息',
  'auto.pages.pages.requirements.feature-list.index.96': '项目名称不能为空',
  'auto.pages.pages.requirements.feature-list.index.97': '项目信息已保存',
  'auto.pages.pages.requirements.feature-list.index.98': '保存项目信息失败:',
  'auto.pages.pages.requirements.feature-list.index.99': '保存项目信息失败',
  'auto.pages.pages.requirements.feature-list.index.100': '缺少需求清单信息',
  'auto.pages.pages.requirements.feature-list.index.101':
    '功能点层级不支持继续拆解',
  'auto.pages.pages.requirements.feature-list.index.102':
    '当前仅支持拆解到功能点层级',
  'auto.pages.pages.requirements.feature-list.index.103':
    '请先在人工录入中至少输入一行',
  'auto.pages.pages.requirements.feature-list.index.104': '已录入 {p1} 个下级',
  'auto.pages.pages.requirements.feature-list.index.105':
    '项目名称：{p1}\n项目简介：{p2}',
  'auto.pages.pages.requirements.feature-list.index.106':
    '请结合项目名称、项目简介与上级功能，尽可能全面地拆解出更多合理下级功能，覆盖主流程、支撑流程、异常流程和管理能力。\n{p1}',
  'auto.pages.pages.requirements.feature-list.index.107': 'AI拆解失败',
  'auto.pages.pages.requirements.feature-list.index.108': 'AI拆解失败',
  'auto.pages.pages.requirements.feature-list.index.109': 'AI拆解未返回结果',
  'auto.pages.pages.requirements.feature-list.index.110':
    '成功拆解出 {p1} 个新的需求项',
  'auto.pages.pages.requirements.feature-list.index.111':
    'AI拆解完成，请查看结果',
  'auto.pages.pages.requirements.feature-list.index.112': '缺少需求清单信息',
  'auto.pages.pages.requirements.feature-list.index.113': '没有拆解结果可确认',
  'auto.pages.pages.requirements.feature-list.index.114': '拆解成功',
  'auto.pages.pages.requirements.feature-list.index.115':
    '未生成可保存的需求项',
  'auto.pages.pages.requirements.feature-list.index.116':
    '成功应用 {p1} 个拆解结果',
  'auto.pages.pages.requirements.feature-list.index.117': '应用拆解结果失败:',
  'auto.pages.pages.requirements.feature-list.index.118': '保存拆解结果失败',
  'auto.pages.pages.requirements.feature-list.index.119': '请先选择需求清单',
  'auto.pages.pages.requirements.feature-list.index.120': '模块',
  'auto.pages.pages.requirements.feature-list.index.121': '功能',
  'auto.pages.pages.requirements.feature-list.index.122': '功能点',
  'auto.pages.pages.requirements.feature-list.index.123': '描述',
  'auto.pages.pages.requirements.feature-list.index.124': '功能点复杂度',
  'auto.pages.pages.requirements.feature-list.index.125': '工时预估',
  'auto.pages.pages.requirements.feature-list.index.126': '状态',
  'auto.pages.pages.requirements.feature-list.index.127': '功能清单',
  'auto.pages.pages.requirements.feature-list.index.128': '功能清单-{p1}.xlsx',
  'auto.pages.pages.requirements.feature-list.index.129': 'Excel文件导出成功',
  'auto.pages.pages.requirements.feature-list.index.130': '导出Excel失败:',
  'auto.pages.pages.requirements.feature-list.index.131': '导出Excel失败',
  'auto.pages.pages.requirements.feature-list.index.132': '请先选择需求清单',
  'auto.pages.pages.requirements.feature-list.index.133': '功能清单-{p1}.xmind',
  'auto.pages.pages.requirements.feature-list.index.134':
    '思维导图文件导出成功',
  'auto.pages.pages.requirements.feature-list.index.135': '导出思维导图失败:',
  'auto.pages.pages.requirements.feature-list.index.136': '导出思维导图失败',
  'auto.pages.pages.requirements.feature-list.index.137': '请先选择需求清单',
  'auto.pages.pages.requirements.feature-list.index.138':
    '\n      <html>\n      <head>\n        <meta charset="UTF-8">\n        <style>\n          body {{\n            font-family: "Microsoft YaHei", "微软雅黑", sans-serif;\n            font-size: 14pt; /* 四号 */\n            line-height: 1.75;\n            color: #111;\n          }}\n          h1, h2, h3, h4 {{\n            font-family: "Microsoft YaHei", "微软雅黑", sans-serif;\n            font-weight: 700;\n            margin: 16pt 0 8pt 0;\n            text-indent: 0;\n            line-height: 1.4;\n          }}\n          h1 {{ font-size: 22pt; }}\n          h2 {{ font-size: 18pt; }}\n          h3 {{ font-size: 16pt; }}\n          h4 {{ font-size: 15pt; }}\n          p {{\n            margin: 6pt 0;\n            text-indent: 2em;\n            font-size: 14pt;\n            line-height: 150%;\n            mso-line-height-rule: exactly;\n            mso-line-height-alt: 150%;\n            text-align: justify;\n            text-justify: inter-ideograph;\n          }}\n        </style>\n      </head>\n      <body>\n        <h1>功能需求</h1>\n        {p1}\n      </body>\n      </html>',
  'auto.pages.pages.requirements.feature-list.index.139': '功能清单-{p1}.doc',
  'auto.pages.pages.requirements.feature-list.index.140': 'Word文件导出成功',
  'auto.pages.pages.requirements.feature-list.index.141': '导出Word失败:',
  'auto.pages.pages.requirements.feature-list.index.142': '导出Word失败',
  'auto.pages.pages.requirements.feature-list.index.143': '读取文件失败',
  'auto.pages.pages.requirements.feature-list.index.144': '{p1} 列 - {p2}',
  'auto.pages.pages.requirements.feature-list.index.145': '(空)',
  'auto.pages.pages.requirements.feature-list.index.146':
    '请先创建并选择需求清单',
  'auto.pages.pages.requirements.feature-list.index.147': '草稿',
  'auto.pages.pages.requirements.feature-list.index.148': '进行中',
  'auto.pages.pages.requirements.feature-list.index.149': '已确认',
  'auto.pages.pages.requirements.feature-list.index.150': '已完成',
  'auto.pages.pages.requirements.feature-list.index.151':
    '导入完成：新增模块 {p1}，新增功能 {p2}，新增功能点 {p3}，描述更新 {p4}（智能合并 {p5}），续行拼接 {p6}，缺少模块跳过 {p7}，无效行 {p8}',
  'auto.pages.pages.requirements.feature-list.index.152': 'Excel导入失败:',
  'auto.pages.pages.requirements.feature-list.index.153': 'Excel导入失败',
  'auto.pages.pages.requirements.feature-list.index.154':
    '请先创建并选择需求清单',
  'auto.pages.pages.requirements.feature-list.index.155':
    '仅支持上传 .xlsx / .xls 文件',
  'auto.pages.pages.requirements.feature-list.index.156':
    'Excel 中没有可导入的数据',
  'auto.pages.pages.requirements.feature-list.index.157': '读取Excel失败:',
  'auto.pages.pages.requirements.feature-list.index.158': '读取Excel失败',
  'auto.pages.pages.requirements.feature-list.index.159': '请先上传 Excel 文件',
  'auto.pages.pages.requirements.feature-list.index.160':
    '忽略行数超出范围，请调整后重试',
  'auto.pages.pages.requirements.feature-list.index.161': '请先配置模块列映射',
  'auto.pages.pages.requirements.feature-list.index.162':
    'Excel 中没有可导入的数据',
  'auto.pages.pages.requirements.feature-list.index.163': '标题不能为空',
  'auto.pages.pages.requirements.feature-list.index.164': '需求项已更新',
  'auto.pages.pages.requirements.feature-list.index.165': '更新需求项失败:',
  'auto.pages.pages.requirements.feature-list.index.166': '更新需求项失败',
  'auto.pages.pages.requirements.feature-list.index.167': '排序更新成功',
  'auto.pages.pages.requirements.feature-list.index.168': '排序更新失败:',
  'auto.pages.pages.requirements.feature-list.index.169': '排序更新失败',
  'auto.pages.pages.requirements.feature-list.index.170': '标题不能为空',
  'auto.pages.pages.requirements.feature-list.index.171':
    '已在下方插入新需求项',
  'auto.pages.pages.requirements.feature-list.index.172': '下方插入失败:',
  'auto.pages.pages.requirements.feature-list.index.173': '下方插入失败',
  'auto.pages.pages.requirements.feature-list.index.174': '缺少需求清单信息',
  'auto.pages.pages.requirements.feature-list.index.175':
    '请先选择模块，或在弹窗中选择“全项目功能”',
  'auto.pages.pages.requirements.feature-list.index.176':
    '当前列没有可拆解的需求项',
  'auto.pages.pages.requirements.feature-list.index.177':
    '功能点层级不支持继续拆解',
  'auto.pages.pages.requirements.feature-list.index.178':
    '当前仅支持拆解到功能点层级',
  'auto.pages.pages.requirements.feature-list.index.179':
    '请在保证层级正确的前提下尽可能多地拆解下级，覆盖主流程、支撑流程、异常流程与管理能力。',
  'auto.pages.pages.requirements.feature-list.index.180': 'AI拆解失败',
  'auto.pages.pages.requirements.feature-list.index.181': 'AI拆解未返回结果',
  'auto.pages.pages.requirements.feature-list.index.182': '拆解成功',
  'auto.pages.pages.requirements.feature-list.index.183':
    '未生成可保存的需求项',
  'auto.pages.pages.requirements.feature-list.index.184': '批量拆解失败: {p1}',
  'auto.pages.pages.requirements.feature-list.index.185':
    '批量拆解完成：成功 {p1} 项，失败 {p2} 项',
  'auto.pages.pages.requirements.feature-list.index.186': '缺少需求清单信息',
  'auto.pages.pages.requirements.feature-list.index.187':
    '已删除 {p1} 个需求项（含下级）',
  'auto.pages.pages.requirements.feature-list.index.188': '删除需求项失败:',
  'auto.pages.pages.requirements.feature-list.index.189': '删除需求项失败',
  'auto.pages.pages.requirements.feature-list.index.190': '删除「{p1}」？',
  'auto.pages.pages.requirements.feature-list.index.191':
    '将同时删除该项及其所有下级需求项，删除后不可恢复。',
  'auto.pages.pages.requirements.feature-list.index.192': '删除',
  'auto.pages.pages.requirements.feature-list.index.193': '取消',
  'auto.pages.pages.requirements.feature-list.index.194': '功能类型:',
  'auto.pages.pages.requirements.feature-list.index.195': '复杂度等级: L',
  'auto.pages.pages.requirements.feature-list.index.196': '预估工时:',
  'auto.pages.pages.requirements.feature-list.index.197': '置顶',
  'auto.pages.pages.requirements.feature-list.index.198': '上移',
  'auto.pages.pages.requirements.feature-list.index.199': '下移',
  'auto.pages.pages.requirements.feature-list.index.200': '置底',
  'auto.pages.pages.requirements.feature-list.index.201': '删除',
  'auto.pages.pages.requirements.feature-list.index.202': '评估',
  'auto.pages.pages.requirements.feature-list.index.203': '下方插入',
  'auto.pages.pages.requirements.feature-list.index.204': '拆解',
  'auto.pages.pages.requirements.feature-list.index.205': '功能清单',
  'auto.pages.pages.requirements.feature-list.index.206':
    '分析项目的功能需求和实现方案，通过层级拆解确保功能覆盖完整',
  'auto.pages.pages.requirements.feature-list.index.207': '选择功能清单',
  'auto.pages.pages.requirements.feature-list.index.208': '新建清单',
  'auto.pages.pages.requirements.feature-list.index.209': '模块数：',
  'auto.pages.pages.requirements.feature-list.index.210': '待拆解模块：',
  'auto.pages.pages.requirements.feature-list.index.211': '功能数：',
  'auto.pages.pages.requirements.feature-list.index.212': '待拆解功能：',
  'auto.pages.pages.requirements.feature-list.index.213': '功能点数：',
  'auto.pages.pages.requirements.feature-list.index.214': '待评估功能点：',
  'auto.pages.pages.requirements.feature-list.index.215': '预估工时：',
  'auto.pages.pages.requirements.feature-list.index.216':
    '口径：仅统计功能点工时',
  'auto.pages.pages.requirements.feature-list.index.217': '选择估算标准',
  'auto.pages.pages.requirements.feature-list.index.218': ' [默认]',
  'auto.pages.pages.requirements.feature-list.index.219': '批量评估',
  'auto.pages.pages.requirements.feature-list.index.220': '请先创建清单',
  'auto.pages.pages.requirements.feature-list.index.221': '开始拆解',
  'auto.pages.pages.requirements.feature-list.index.222': '确认清空',
  'auto.pages.pages.requirements.feature-list.index.223':
    '确定要清空当前需求清单的所有功能项吗？',
  'auto.pages.pages.requirements.feature-list.index.224':
    '已清空所有功能需求项',
  'auto.pages.pages.requirements.feature-list.index.225': '清空',
  'auto.pages.pages.requirements.feature-list.index.226': 'Excel导入',
  'auto.pages.pages.requirements.feature-list.index.227': '导出 Excel',
  'auto.pages.pages.requirements.feature-list.index.228': '导出 Word',
  'auto.pages.pages.requirements.feature-list.index.229': '导出思维导图',
  'auto.pages.pages.requirements.feature-list.index.230': '导出',
  'auto.pages.pages.requirements.feature-list.index.231': '编辑清单',
  'auto.pages.pages.requirements.feature-list.index.232': '删除清单',
  'auto.pages.pages.requirements.feature-list.index.233': '删除清单「{p1}」？',
  'auto.pages.pages.requirements.feature-list.index.234':
    '删除后不可恢复，请确认是否继续。',
  'auto.pages.pages.requirements.feature-list.index.235': '删除',
  'auto.pages.pages.requirements.feature-list.index.236': '取消',
  'auto.pages.pages.requirements.feature-list.index.237': '设置为默认清单',
  'auto.pages.pages.requirements.feature-list.index.238': '功能解析',
  'auto.pages.pages.requirements.feature-list.index.239':
    '当前项目还没有功能清单',
  'auto.pages.pages.requirements.feature-list.index.240': '创建清单',
  'auto.pages.pages.requirements.feature-list.index.241': '功能模块',
  'auto.pages.pages.requirements.feature-list.index.242': '确认清空全部模块？',
  'auto.pages.pages.requirements.feature-list.index.243': '清空',
  'auto.pages.pages.requirements.feature-list.index.244': '拆解更多',
  'auto.pages.pages.requirements.feature-list.index.245': '批量拆解',
  'auto.pages.pages.requirements.feature-list.index.246': '正在加载...',
  'auto.pages.pages.requirements.feature-list.index.247': '个子功能',
  'auto.pages.pages.requirements.feature-list.index.248':
    '当前还没有功能模块，请点击“开始拆解”',
  'auto.pages.pages.requirements.feature-list.index.249': '拆解更多',
  'auto.pages.pages.requirements.feature-list.index.250': '功能',
  'auto.pages.pages.requirements.feature-list.index.251': '清空本模块下功能',
  'auto.pages.pages.requirements.feature-list.index.252':
    '确认清空模块「{p1}」下全部功能？',
  'auto.pages.pages.requirements.feature-list.index.253': '清空所有功能',
  'auto.pages.pages.requirements.feature-list.index.254':
    '确认清空全清单所有功能？',
  'auto.pages.pages.requirements.feature-list.index.255': '清空',
  'auto.pages.pages.requirements.feature-list.index.256': '拆解更多',
  'auto.pages.pages.requirements.feature-list.index.257': '批量拆解',
  'auto.pages.pages.requirements.feature-list.index.258': '正在加载功能列表...',
  'auto.pages.pages.requirements.feature-list.index.259': '个功能点',
  'auto.pages.pages.requirements.feature-list.index.260': '当前模块暂无功能',
  'auto.pages.pages.requirements.feature-list.index.261': '请先选择功能模块',
  'auto.pages.pages.requirements.feature-list.index.262': '拆解更多',
  'auto.pages.pages.requirements.feature-list.index.263': '功能点',
  'auto.pages.pages.requirements.feature-list.index.264': '清空本功能下功能点',
  'auto.pages.pages.requirements.feature-list.index.265':
    '确认清空功能「{p1}」下全部功能点？',
  'auto.pages.pages.requirements.feature-list.index.266': '清空所有功能点',
  'auto.pages.pages.requirements.feature-list.index.267':
    '确认清空全清单所有功能点？',
  'auto.pages.pages.requirements.feature-list.index.268': '清空',
  'auto.pages.pages.requirements.feature-list.index.269': '批量评估',
  'auto.pages.pages.requirements.feature-list.index.270':
    '正在加载功能点列表...',
  'auto.pages.pages.requirements.feature-list.index.271': '当前功能暂无功能点',
  'auto.pages.pages.requirements.feature-list.index.272': '请先选择功能',
  'auto.pages.pages.requirements.feature-list.index.273': '表格视图',
  'auto.pages.pages.requirements.feature-list.index.274': '思维导图',
  'auto.pages.pages.requirements.feature-list.index.275': '新建清单',
  'auto.pages.pages.requirements.feature-list.index.276': '编辑清单',
  'auto.pages.pages.requirements.feature-list.index.277': '创建',
  'auto.pages.pages.requirements.feature-list.index.278': '保存',
  'auto.pages.pages.requirements.feature-list.index.279': '清单名称',
  'auto.pages.pages.requirements.feature-list.index.280': '请输入清单名称',
  'auto.pages.pages.requirements.feature-list.index.281':
    '清单名称不能超过 200 个字符',
  'auto.pages.pages.requirements.feature-list.index.282': '请输入清单名称',
  'auto.pages.pages.requirements.feature-list.index.283': '版本号',
  'auto.pages.pages.requirements.feature-list.index.284': '请输入版本号',
  'auto.pages.pages.requirements.feature-list.index.285':
    '版本号不能超过 50 个字符',
  'auto.pages.pages.requirements.feature-list.index.286': '例如：1.0.0',
  'auto.pages.pages.requirements.feature-list.index.287': '描述',
  'auto.pages.pages.requirements.feature-list.index.288': '请输入清单描述',
  'auto.pages.pages.requirements.feature-list.index.289': 'Excel 导入配置{p1}',
  'auto.pages.pages.requirements.feature-list.index.290': '导入中...',
  'auto.pages.pages.requirements.feature-list.index.291': '确认导入',
  'auto.pages.pages.requirements.feature-list.index.292': '忽略前几行',
  'auto.pages.pages.requirements.feature-list.index.293': '请输入忽略行数',
  'auto.pages.pages.requirements.feature-list.index.294':
    '第 N+1 行作为表头候选。当前总行数：{p1}',
  'auto.pages.pages.requirements.feature-list.index.295': '模块列',
  'auto.pages.pages.requirements.feature-list.index.296': '请配置模块列映射',
  'auto.pages.pages.requirements.feature-list.index.297': '请选择模块列',
  'auto.pages.pages.requirements.feature-list.index.298': '功能列',
  'auto.pages.pages.requirements.feature-list.index.299':
    '请选择功能列（可选）',
  'auto.pages.pages.requirements.feature-list.index.300': '功能点列',
  'auto.pages.pages.requirements.feature-list.index.301':
    '请选择功能点列（可选）',
  'auto.pages.pages.requirements.feature-list.index.302': '模块描述列',
  'auto.pages.pages.requirements.feature-list.index.303':
    '请选择模块描述列（可选）',
  'auto.pages.pages.requirements.feature-list.index.304': '功能描述列',
  'auto.pages.pages.requirements.feature-list.index.305':
    '请选择功能描述列（可选）',
  'auto.pages.pages.requirements.feature-list.index.306': '功能点描述列',
  'auto.pages.pages.requirements.feature-list.index.307':
    '请选择功能点描述列（可选）',
  'auto.pages.pages.requirements.feature-list.index.308': '表头预览（第',
  'auto.pages.pages.requirements.feature-list.index.309': '行）',
  'auto.pages.pages.requirements.feature-list.index.310':
    '当前表头行为空，请调整忽略行数',
  'auto.pages.pages.requirements.feature-list.index.311':
    '映射后预览（最多 8 行）',
  'auto.pages.pages.requirements.feature-list.index.312': '正在解析预览...',
  'auto.pages.pages.requirements.feature-list.index.313':
    '配置映射后将显示预览',
  'auto.pages.pages.requirements.feature-list.index.314': '批量工时评估',
  'auto.pages.pages.requirements.feature-list.index.315': '评估中...',
  'auto.pages.pages.requirements.feature-list.index.316': '开始评估',
  'auto.pages.pages.requirements.feature-list.index.317': '估算标准',
  'auto.pages.pages.requirements.feature-list.index.318': '请选择估算标准',
  'auto.pages.pages.requirements.feature-list.index.319': ' [默认]',
  'auto.pages.pages.requirements.feature-list.index.320': '请选择估算标准',
  'auto.pages.pages.requirements.feature-list.index.321': '评估范围',
  'auto.pages.pages.requirements.feature-list.index.322': '请选择评估范围',
  'auto.pages.pages.requirements.feature-list.index.323': '全清单叶子项',
  'auto.pages.pages.requirements.feature-list.index.324': '当前模块子树',
  'auto.pages.pages.requirements.feature-list.index.325': '当前功能子树',
  'auto.pages.pages.requirements.feature-list.index.326': '仅评估未填写工时项',
  'auto.pages.pages.requirements.feature-list.index.327': '评估提示',
  'auto.pages.pages.requirements.feature-list.index.328':
    '可选：输入本次评估偏好，例如优先稳定性、降低复杂度、强调后端性能等',
  'auto.pages.pages.requirements.feature-list.index.329': '进度：',
  'auto.pages.pages.requirements.feature-list.index.330': '， 成功',
  'auto.pages.pages.requirements.feature-list.index.331': '，失败',
  'auto.pages.pages.requirements.feature-list.index.332': '，跳过',
  'auto.pages.pages.requirements.feature-list.index.333': '当前处理：',
  'auto.pages.pages.requirements.feature-list.index.334':
    '正在后台逐项评估，完成数量将在任务结束后更新',
  'auto.pages.pages.requirements.feature-list.index.335': '下方插入需求项',
  'auto.pages.pages.requirements.feature-list.index.336': '标题',
  'auto.pages.pages.requirements.feature-list.index.337': '请输入标题',
  'auto.pages.pages.requirements.feature-list.index.338': '请输入需求项标题',
  'auto.pages.pages.requirements.feature-list.index.339': '描述',
  'auto.pages.pages.requirements.feature-list.index.340': '请输入需求项描述',
  'auto.pages.pages.requirements.feature-list.index.341': '语义类型',
  'auto.pages.pages.requirements.feature-list.index.342': '请选择语义类型',
  'auto.pages.pages.requirements.feature-list.index.343':
    '请选择功能点技术类型',
  'auto.pages.pages.requirements.feature-list.index.344': '复杂度等级（1-5）',
  'auto.pages.pages.requirements.feature-list.index.345': '评估工时（小时）',
  'auto.pages.pages.requirements.feature-list.index.346': '实际工时（小时）',
  'auto.pages.pages.requirements.feature-list.index.347': '任务拆解',
  'auto.pages.pages.requirements.feature-list.index.348':
    '按任务拆解大致实现逻辑，例如：1) 搭建接口 2) 完成页面联调 3) 回归测试',
  'auto.pages.pages.requirements.feature-list.index.349': '批量拆解配置 - {p1}',
  'auto.pages.pages.requirements.feature-list.index.350': '功能模块列',
  'auto.pages.pages.requirements.feature-list.index.351': '功能列',
  'auto.pages.pages.requirements.feature-list.index.352': '执行中...',
  'auto.pages.pages.requirements.feature-list.index.353': '完成并关闭',
  'auto.pages.pages.requirements.feature-list.index.354': '开始批量拆解',
  'auto.pages.pages.requirements.feature-list.index.355': '拆解模式',
  'auto.pages.pages.requirements.feature-list.index.356': 'A、尽可能多',
  'auto.pages.pages.requirements.feature-list.index.357': 'B、指定数量',
  'auto.pages.pages.requirements.feature-list.index.358': '默认拆解的需求数量',
  'auto.pages.pages.requirements.feature-list.index.359': '请输入拆解数量',
  'auto.pages.pages.requirements.feature-list.index.360': '拆解提示',
  'auto.pages.pages.requirements.feature-list.index.361':
    '可选：给批量拆解一个通用提示',
  'auto.pages.pages.requirements.feature-list.index.362':
    '例如：优先覆盖核心业务流程和关键异常场景',
  'auto.pages.pages.requirements.feature-list.index.363': '功能列拆解范围',
  'auto.pages.pages.requirements.feature-list.index.364':
    '将遍历所有模块下的功能项进行批量拆解',
  'auto.pages.pages.requirements.feature-list.index.365':
    '仅拆解当前选中模块下的功能项',
  'auto.pages.pages.requirements.feature-list.index.366': '当前模块功能',
  'auto.pages.pages.requirements.feature-list.index.367': '全项目功能',
  'auto.pages.pages.requirements.feature-list.index.368':
    '是否参考本项目需求概要',
  'auto.pages.pages.requirements.feature-list.index.369': '是否覆盖重名需求项',
  'auto.pages.pages.requirements.feature-list.index.370':
    '只拆解没有子项的需求',
  'auto.pages.pages.requirements.feature-list.index.371': '进度：',
  'auto.pages.pages.requirements.feature-list.index.372': '， 成功',
  'auto.pages.pages.requirements.feature-list.index.373': '，失败',
  'auto.pages.pages.requirements.feature-list.index.374': '当前处理：',
  'auto.pages.pages.requirements.feature-list.index.375': '编辑需求项',
  'auto.pages.pages.requirements.feature-list.index.376': '标题',
  'auto.pages.pages.requirements.feature-list.index.377': '请输入标题',
  'auto.pages.pages.requirements.feature-list.index.378': '请输入需求项标题',
  'auto.pages.pages.requirements.feature-list.index.379': '描述',
  'auto.pages.pages.requirements.feature-list.index.380': '请输入需求项描述',
  'auto.pages.pages.requirements.feature-list.index.381': '语义类型',
  'auto.pages.pages.requirements.feature-list.index.382': '请选择语义类型',
  'auto.pages.pages.requirements.feature-list.index.383':
    '请选择功能点技术类型',
  'auto.pages.pages.requirements.feature-list.index.384': '复杂度等级（1-5）',
  'auto.pages.pages.requirements.feature-list.index.385': '评估工时（小时）',
  'auto.pages.pages.requirements.feature-list.index.386': '实际工时（小时）',
  'auto.pages.pages.requirements.feature-list.index.387': '任务拆解',
  'auto.pages.pages.requirements.feature-list.index.388':
    '按任务拆解大致实现逻辑，例如：1) 搭建接口 2) 完成页面联调 3) 回归测试',
  'auto.pages.pages.requirements.feature-list.index.389': 'AI智能拆解',
  'auto.pages.pages.requirements.feature-list.index.390': '取消',
  'auto.pages.pages.requirements.feature-list.index.391': '覆盖重名需求项',
  'auto.pages.pages.requirements.feature-list.index.392': '确认应用 (',
  'auto.pages.pages.requirements.feature-list.index.393': '拆解参数',
  'auto.pages.pages.requirements.feature-list.index.394': '当前项目',
  'auto.pages.pages.requirements.feature-list.index.395': '项目名称',
  'auto.pages.pages.requirements.feature-list.index.396': '项目简介',
  'auto.pages.pages.requirements.feature-list.index.397': '保存项目信息',
  'auto.pages.pages.requirements.feature-list.index.398': '拆解模式',
  'auto.pages.pages.requirements.feature-list.index.399': 'A、尽可能多',
  'auto.pages.pages.requirements.feature-list.index.400': 'B、指定数量',
  'auto.pages.pages.requirements.feature-list.index.401': 'C、人工录入',
  'auto.pages.pages.requirements.feature-list.index.402': '拆解数量',
  'auto.pages.pages.requirements.feature-list.index.403': '请输入拆解数量',
  'auto.pages.pages.requirements.feature-list.index.404':
    '人工录入（每行一个下级）',
  'auto.pages.pages.requirements.feature-list.index.405': '请至少输入一行',
  'auto.pages.pages.requirements.feature-list.index.406':
    '例如：\n用户画像\n标签管理\n客户分群',
  'auto.pages.pages.requirements.feature-list.index.407': '拆解提示',
  'auto.pages.pages.requirements.feature-list.index.408':
    '可选：提供额外的拆解指导，帮助AI更好地理解需求',
  'auto.pages.pages.requirements.feature-list.index.409':
    '例如：重点关注用户交互、数据流程、业务规则等',
  'auto.pages.pages.requirements.feature-list.index.410': '参考本项目需求概要',
  'auto.pages.pages.requirements.feature-list.index.411': '添加录入结果',
  'auto.pages.pages.requirements.feature-list.index.412': '开始拆解',
  'auto.pages.pages.requirements.feature-list.index.413': '追加录入',
  'auto.pages.pages.requirements.feature-list.index.414': '拆解更多',
  'auto.pages.pages.requirements.feature-list.index.415': '重新拆解完成',
  'auto.pages.pages.requirements.feature-list.index.416': '重新拆解',
  'auto.pages.pages.requirements.feature-list.index.417': '拆解结果',
  'auto.pages.pages.requirements.feature-list.index.418': '共',
  'auto.pages.pages.requirements.feature-list.index.419': '项',
  'auto.pages.pages.requirements.feature-list.index.420': '优先级:',
  'auto.pages.pages.requirements.feature-list.index.421': '复杂度等级: L',
  'auto.pages.pages.requirements.feature-list.index.422':
    '点击“开始拆解”生成结果',
  'auto.pages.pages.requirements.overview.index.1': 'SaaS 管理系统',
  'auto.pages.pages.requirements.overview.index.2':
    '适用于中后台管理、工作流与权限协同类系统',
  'auto.pages.pages.requirements.overview.index.3':
    '# 需求概要\n\n## 项目背景与目标\n### 业务背景\n### 核心目标\n### 成功指标\n\n## 范围定义\n### 本期范围（In Scope）\n### 非本期范围（Out of Scope）\n### 边界与约束\n\n## 用户与场景\n### 角色定义\n### 关键业务场景\n### 核心用户旅程\n\n## 功能需求概要\n### 核心功能模块\n### 关键流程说明\n### 异常与兜底策略\n\n## 非功能需求\n### 性能与容量\n### 安全与权限\n### 可用性与可观测性\n\n## 依赖与风险\n### 外部依赖\n### 主要风险\n### 风险应对策略\n\n## 里程碑与验收\n### 阶段规划\n### 验收标准',
  'auto.pages.pages.requirements.overview.index.4': '移动应用产品',
  'auto.pages.pages.requirements.overview.index.5':
    '适用于 App、小程序、移动端服务类产品',
  'auto.pages.pages.requirements.overview.index.6':
    '# 需求概要\n\n## 产品定位\n### 目标用户\n### 核心价值主张\n### 竞品与差异化\n\n## 业务范围\n### MVP 范围\n### 版本演进规划\n### 不做项说明\n\n## 核心体验流程\n### 首次使用流程\n### 高频任务路径\n### 关键转化路径\n\n## 功能需求概要\n### 账户与身份\n### 内容/服务主流程\n### 消息与提醒\n\n## 质量与技术要求\n### 启动与响应性能\n### 弱网与离线策略\n### 终端兼容性\n\n## 商业与运营约束\n### 转化与留存指标\n### 增长与活动支持\n### 合规要求\n\n## 发布与验收\n### 发布节奏\n### 验收口径',
  'auto.pages.pages.requirements.overview.index.7': '数据平台/分析系统',
  'auto.pages.pages.requirements.overview.index.8':
    '适用于数据采集、建模、分析与报表平台',
  'auto.pages.pages.requirements.overview.index.9':
    '# 需求概要\n\n## 建设目标\n### 业务问题定义\n### 数据化目标\n### 指标体系范围\n\n## 数据范围与边界\n### 数据源与采集范围\n### 数据时效要求\n### 数据质量边界\n\n## 核心能力需求\n### 数据接入与处理\n### 指标建模与口径管理\n### 查询分析与可视化\n\n## 用户与使用场景\n### 分析师场景\n### 业务方场景\n### 管理层场景\n\n## 非功能需求\n### 数据准确性与一致性\n### 性能与成本控制\n### 权限与数据安全\n\n## 风险与依赖\n### 上游系统依赖\n### 口径争议风险\n### 上线风险与预案\n\n## 里程碑与验收\n### 交付阶段\n### 验收标准',
  'auto.pages.pages.requirements.overview.index.109': '产品构思',
  'auto.pages.pages.requirements.overview.index.110':
    '适用于新产品方向探索与概念设计阶段',
  'auto.pages.pages.requirements.overview.index.111':
    '# 产品构思\n\n## 产品基本描述\n### 产品定位\n### 目标用户\n### 用户痛点与需求\n\n## 核心功能\n### 核心功能清单\n### 关键用户流程\n### MVP 功能边界\n\n## 核心创新点\n### 创新能力说明\n### 差异化价值\n### 可验证假设与验证方式\n\n## 商业与落地\n### 商业模式初步设想\n### 资源与实施约束\n### 阶段目标与里程碑',
  'auto.pages.pages.requirements.overview.index.10':
    '你好，我可以和你讨论当前概要内容。\n切到 Agent 模式后，我会在讨论后直接修改正文。',
  'auto.pages.pages.requirements.overview.index.11': '请先保存概要后再开始对话',
  'auto.pages.pages.requirements.overview.index.12': '对话失败，请稍后重试',
  'auto.pages.pages.requirements.overview.index.13':
    '调用对话接口失败，请检查后端服务与登录状态。',
  'auto.pages.pages.requirements.overview.index.14':
    '已撤销上一次 Agent 修改。',
  'auto.pages.pages.requirements.overview.index.15':
    '全屏切换失败，请检查浏览器权限',
  'auto.pages.pages.requirements.overview.index.16': '重置',
  'auto.pages.pages.requirements.overview.index.17': '保存版本',
  'auto.pages.pages.requirements.overview.index.18': '保存',
  'auto.pages.pages.requirements.overview.index.19': '折叠左侧大纲',
  'auto.pages.pages.requirements.overview.index.20': '展开左侧大纲',
  'auto.pages.pages.requirements.overview.index.21': '大纲',
  'auto.pages.pages.requirements.overview.index.22': '折叠右侧对话',
  'auto.pages.pages.requirements.overview.index.23': '展开右侧对话',
  'auto.pages.pages.requirements.overview.index.24': '对话',
  'auto.pages.pages.requirements.overview.index.25': '一键Zen',
  'auto.pages.pages.requirements.overview.index.26': '退出全屏',
  'auto.pages.pages.requirements.overview.index.27': '全屏',
  'auto.pages.pages.requirements.overview.index.28': '大纲',
  'auto.pages.pages.requirements.overview.index.29': '展开',
  'auto.pages.pages.requirements.overview.index.30': '折叠',
  'auto.pages.pages.requirements.overview.index.31':
    '暂无标题，输入 # / ## / ### 生成大纲',
  'auto.pages.pages.requirements.overview.index.32': '对话',
  'auto.pages.pages.requirements.overview.index.33': '讨论',
  'auto.pages.pages.requirements.overview.index.34': '你',
  'auto.pages.pages.requirements.overview.index.35': '讨论助手',
  'auto.pages.pages.requirements.overview.index.36': '处理中...',
  'auto.pages.pages.requirements.overview.index.37':
    '输入讨论内容（仅建议，不改正文）',
  'auto.pages.pages.requirements.overview.index.38':
    '输入需求（将自动修改正文）',
  'auto.pages.pages.requirements.overview.index.39': '撤销Agent修改',
  'auto.pages.pages.requirements.overview.index.40': '发送',
  'auto.pages.pages.requirements.overview.index.41':
    '# 需求概要\n\n## 目标\n- 建立项目级管理工作台\n\n## 范围\n- 项目列表\n- 项目详情与菜单\n\n## 风险\n- 外部系统接口待联调',
  'auto.pages.pages.requirements.overview.index.42': '加载概要需求失败',
  'auto.pages.pages.requirements.overview.index.43': '请先选择项目',
  'auto.pages.pages.requirements.overview.index.44': '请输入概要内容',
  'auto.pages.pages.requirements.overview.index.45': '请先创建需求概要',
  'auto.pages.pages.requirements.overview.index.46': '概要已更新',
  'auto.pages.pages.requirements.overview.index.47': '保存概要需求失败',
  'auto.pages.pages.requirements.overview.index.48': '请先选择项目',
  'auto.pages.pages.requirements.overview.index.49':
    '需求概要已创建并关联到当前项目',
  'auto.pages.pages.requirements.overview.index.50': '创建需求概要失败',
  'auto.pages.pages.requirements.overview.index.51': '概要已删除',
  'auto.pages.pages.requirements.overview.index.52': '删除概要需求失败',
  'auto.pages.pages.requirements.overview.index.53': '已重置到最近保存内容',
  'auto.pages.pages.requirements.overview.index.54': '版本快照已保存',
  'auto.pages.pages.requirements.overview.index.55': '请先选择项目',
  'auto.pages.pages.requirements.overview.index.56': '请先选择项目',
  'auto.pages.pages.requirements.overview.index.57': '请输入项目名称',
  'auto.pages.pages.requirements.overview.index.58': '请选择或输入模板内容',
  'auto.pages.pages.requirements.overview.index.59':
    '未生成有效内容，请调整提示信息后重试',
  'auto.pages.pages.requirements.overview.index.60': '已生成概要草稿{p1}',
  'auto.pages.pages.requirements.overview.index.61': 'AI生成失败，请稍后重试',
  'auto.pages.pages.requirements.overview.index.62': '请先选择项目',
  'auto.pages.pages.requirements.overview.index.63': '请输入项目名称',
  'auto.pages.pages.requirements.overview.index.64': '项目信息已保存',
  'auto.pages.pages.requirements.overview.index.65': '保存项目信息失败',
  'auto.pages.pages.requirements.overview.index.66': '需求概要',
  'auto.pages.pages.requirements.overview.index.67':
    '先形成粗粒度 Markdown 文档，用于确认方向与范围',
  'auto.pages.pages.requirements.overview.index.68': 'AI 生成概要',
  'auto.pages.pages.requirements.overview.index.69': '创建需求概要',
  'auto.pages.pages.requirements.overview.index.70': '确认删除当前概要？',
  'auto.pages.pages.requirements.overview.index.71': '删除概要',
  'auto.pages.pages.requirements.overview.index.72': '概要文档信息',
  'auto.pages.pages.requirements.overview.index.73': '系统录入',
  'auto.pages.pages.requirements.overview.index.74': '暂无',
  'auto.pages.pages.requirements.overview.index.75': '自定义 Markdown',
  'auto.pages.pages.requirements.overview.index.76': '尚未创建概要',
  'auto.pages.pages.requirements.overview.index.77': '已保存',
  'auto.pages.pages.requirements.overview.index.78': '未创建',
  'auto.pages.pages.requirements.overview.index.79': '来源',
  'auto.pages.pages.requirements.overview.index.80': '模板',
  'auto.pages.pages.requirements.overview.index.81': '负责人',
  'auto.pages.pages.requirements.overview.index.82': '版本',
  'auto.pages.pages.requirements.overview.index.83': '状态',
  'auto.pages.pages.requirements.overview.index.84': '未创建',
  'auto.pages.pages.requirements.overview.index.85': '更新时间',
  'auto.pages.pages.requirements.overview.index.86': 'AI 生成概要',
  'auto.pages.pages.requirements.overview.index.87': '项目名称',
  'auto.pages.pages.requirements.overview.index.88': '请输入项目名称',
  'auto.pages.pages.requirements.overview.index.89': '项目简介',
  'auto.pages.pages.requirements.overview.index.90': '请输入项目简介',
  'auto.pages.pages.requirements.overview.index.91': '提示信息（用于辅助生成）',
  'auto.pages.pages.requirements.overview.index.92':
    '例如：重点补充权限模型、外部系统依赖与验收标准',
  'auto.pages.pages.requirements.overview.index.93': '保存项目信息',
  'auto.pages.pages.requirements.overview.index.94': '取消',
  'auto.pages.pages.requirements.overview.index.95': '生成',
  'auto.pages.pages.requirements.overview.index.96': '概要需求模板',
  'auto.pages.pages.requirements.overview.index.97':
    '模板大纲（Markdown，可编辑）',
  'auto.pages.pages.requirements.overview.index.98': '请选择模板后可直接编辑',
  'auto.pages.pages.requirements.overview.index.99': 'Markdown 概要',
  'auto.pages.pages.requirements.overview.index.100': '当前项目还没有需求概要',
  'auto.pages.pages.requirements.overview.index.101': '创建需求概要',
  'auto.pages.pages.requirements.overview.index.102': '保存并更新',
  'auto.pages.pages.requirements.overview.index.103': '创建概要',
  'auto.pages.pages.requirements.overview.index.104': '重置',
  'auto.pages.pages.requirements.overview.index.105': '概要内容',
  'auto.pages.pages.requirements.overview.index.106': '请输入概要内容',
  'auto.pages.pages.requirements.overview.index.107':
    '请输入概要内容（支持段落、列表、代码块等）',
  'auto.pages.pages.requirements.overview.index.108':
    '可基于模板自动生成初稿，再人工修订。当前内容将与后端的概要需求实体同步。',
  'auto.pages.pages.requirements.requirement-pool.index.1': '客户访谈',
  'auto.pages.pages.requirements.requirement-pool.index.2': '产品评审',
  'auto.pages.pages.requirements.requirement-pool.index.3': '运营反馈',
  'auto.pages.pages.requirements.requirement-pool.index.4': '销售反馈',
  'auto.pages.pages.requirements.requirement-pool.index.5': '研发建议',
  'auto.pages.pages.requirements.requirement-pool.index.6': '内部优化',
  'auto.pages.pages.requirements.requirement-pool.index.7': 'AI 实验',
  'auto.pages.pages.requirements.requirement-pool.index.8': '高',
  'auto.pages.pages.requirements.requirement-pool.index.9': '中',
  'auto.pages.pages.requirements.requirement-pool.index.10': '低',
  'auto.pages.pages.requirements.requirement-pool.index.11': '待评估',
  'auto.pages.pages.requirements.requirement-pool.index.12': '待处理',
  'auto.pages.pages.requirements.requirement-pool.index.13': '评估中',
  'auto.pages.pages.requirements.requirement-pool.index.14': '已纳入',
  'auto.pages.pages.requirements.requirement-pool.index.15': '已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.16': '编号',
  'auto.pages.pages.requirements.requirement-pool.index.17': '需求项',
  'auto.pages.pages.requirements.requirement-pool.index.18': '来源',
  'auto.pages.pages.requirements.requirement-pool.index.19': '提出人',
  'auto.pages.pages.requirements.requirement-pool.index.20': '价值评估',
  'auto.pages.pages.requirements.requirement-pool.index.21': '处理状态',
  'auto.pages.pages.requirements.requirement-pool.index.22': '更新时间',
  'auto.pages.pages.requirements.requirement-pool.index.23': '创建时间',
  'auto.pages.pages.requirements.requirement-pool.index.24': '操作',
  'auto.pages.pages.requirements.requirement-pool.index.25': '标记为已纳入',
  'auto.pages.pages.requirements.requirement-pool.index.26': '标记为已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.27': '标记为评估中',
  'auto.pages.pages.requirements.requirement-pool.index.28': '编辑',
  'auto.pages.pages.requirements.requirement-pool.index.29':
    '确认删除该需求项？',
  'auto.pages.pages.requirements.requirement-pool.index.30': '删除后无法恢复',
  'auto.pages.pages.requirements.requirement-pool.index.31': '删除',
  'auto.pages.pages.requirements.requirement-pool.index.32': '取消',
  'auto.pages.pages.requirements.requirement-pool.index.33': '删除中...',
  'auto.pages.pages.requirements.requirement-pool.index.34': '删除失败',
  'auto.pages.pages.requirements.requirement-pool.index.35': '删除成功',
  'auto.pages.pages.requirements.requirement-pool.index.36': '删除',
  'auto.pages.pages.requirements.requirement-pool.index.37': '处理中...',
  'auto.pages.pages.requirements.requirement-pool.index.38': '更新失败',
  'auto.pages.pages.requirements.requirement-pool.index.39': '状态已更新',
  'auto.pages.pages.requirements.requirement-pool.index.40': '更多',
  'auto.pages.pages.requirements.requirement-pool.index.41': '全部 ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.42': '待处理 ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.43': '评估中 ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.44': '已纳入 ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.45': '已清洗 ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.46':
    '请先选择需要处理的需求项',
  'auto.pages.pages.requirements.requirement-pool.index.47': '批量处理失败',
  'auto.pages.pages.requirements.requirement-pool.index.48':
    '已处理 {p1} 条需求',
  'auto.pages.pages.requirements.requirement-pool.index.49': '确认批量{p1}？',
  'auto.pages.pages.requirements.requirement-pool.index.50':
    '本次将处理 {p1} 条需求',
  'auto.pages.pages.requirements.requirement-pool.index.51': '确认',
  'auto.pages.pages.requirements.requirement-pool.index.52': '取消',
  'auto.pages.pages.requirements.requirement-pool.index.53': '需求池',
  'auto.pages.pages.requirements.requirement-pool.index.54':
    '快速记录候选需求，完成评估、清洗与纳入决策',
  'auto.pages.pages.requirements.requirement-pool.index.55': '关键词',
  'auto.pages.pages.requirements.requirement-pool.index.56':
    '标题/需求池编号/提出人',
  'auto.pages.pages.requirements.requirement-pool.index.57': '需求来源',
  'auto.pages.pages.requirements.requirement-pool.index.58': '请选择',
  'auto.pages.pages.requirements.requirement-pool.index.59': '价值评估',
  'auto.pages.pages.requirements.requirement-pool.index.60': '请选择',
  'auto.pages.pages.requirements.requirement-pool.index.61': '处理状态',
  'auto.pages.pages.requirements.requirement-pool.index.62': '请选择',
  'auto.pages.pages.requirements.requirement-pool.index.63': '重置',
  'auto.pages.pages.requirements.requirement-pool.index.64': '查询',
  'auto.pages.pages.requirements.requirement-pool.index.65': '收起',
  'auto.pages.pages.requirements.requirement-pool.index.66': '展开',
  'auto.pages.pages.requirements.requirement-pool.index.67': '刷新',
  'auto.pages.pages.requirements.requirement-pool.index.68': '标记为评估中',
  'auto.pages.pages.requirements.requirement-pool.index.69': '批量评估',
  'auto.pages.pages.requirements.requirement-pool.index.70': '标记为已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.71': '批量清洗',
  'auto.pages.pages.requirements.requirement-pool.index.72': '新增',
  'auto.pages.pages.requirements.requirement-pool.index.73': '已选择',
  'auto.pages.pages.requirements.requirement-pool.index.74': '项',
  'auto.pages.pages.requirements.requirement-pool.index.75': '清空选择',
  'auto.pages.pages.requirements.requirement-pool.index.76': '标记为已纳入',
  'auto.pages.pages.requirements.requirement-pool.index.77': '批量纳入',
  'auto.pages.pages.requirements.requirement-pool.index.78': '标记为已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.79': '批量清洗',
  'auto.pages.pages.requirements.requirement-pool.index.80': '共 {p1} 条',
  'auto.pages.pages.requirements.requirement-pool.index.81': '编辑需求项',
  'auto.pages.pages.requirements.requirement-pool.index.82': '新增需求项',
  'auto.pages.pages.requirements.requirement-pool.index.83': '内部优化',
  'auto.pages.pages.requirements.requirement-pool.index.84': '产品经理',
  'auto.pages.pages.requirements.requirement-pool.index.85': '保存',
  'auto.pages.pages.requirements.requirement-pool.index.86': '取消',
  'auto.pages.pages.requirements.requirement-pool.index.87': '保存失败',
  'auto.pages.pages.requirements.requirement-pool.index.88': '更新成功',
  'auto.pages.pages.requirements.requirement-pool.index.89': '新增成功',
  'auto.pages.pages.requirements.requirement-pool.index.90': '需求项',
  'auto.pages.pages.requirements.requirement-pool.index.91': '请输入需求标题',
  'auto.pages.pages.requirements.requirement-pool.index.92': '请输入需求项',
  'auto.pages.pages.requirements.requirement-pool.index.93': '需求来源',
  'auto.pages.pages.requirements.requirement-pool.index.94': '请选择需求来源',
  'auto.pages.pages.requirements.requirement-pool.index.95': '提出人',
  'auto.pages.pages.requirements.requirement-pool.index.96': '请输入提出人',
  'auto.pages.pages.requirements.requirement-pool.index.97': '请输入提出人',
  'auto.pages.pages.requirements.requirement-pool.index.98': '价值评估',
  'auto.pages.pages.requirements.requirement-pool.index.99': '请选择价值评估',
  'auto.pages.pages.requirements.requirement-pool.index.100': '处理状态',
  'auto.pages.pages.requirements.requirement-pool.index.101': '请选择处理状态',
  'auto.pages.pages.requirements.requirement-pool.index.102': '备注',
  'auto.pages.pages.requirements.requirement-pool.index.103':
    '补充评估结论或上下文',
  'auto.pages.pages.requirements.role-analysis.index.1': '未命名项目',
  'auto.pages.pages.requirements.role-analysis.index.2': '加载角色分析失败',
  'auto.pages.pages.requirements.role-analysis.index.3':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.role-analysis.index.4': '项目信息已保存',
  'auto.pages.pages.requirements.role-analysis.index.5': '保存项目信息失败',
  'auto.pages.pages.requirements.role-analysis.index.6':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.role-analysis.index.7':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.requirements.role-analysis.index.8': 'AI 生成失败',
  'auto.pages.pages.requirements.role-analysis.index.9':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.role-analysis.index.10': '请先勾选预览角色',
  'auto.pages.pages.requirements.role-analysis.index.11':
    '已添加并保存 {p1} 个角色',
  'auto.pages.pages.requirements.role-analysis.index.12': '添加失败',
  'auto.pages.pages.requirements.role-analysis.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.role-analysis.index.14': '保存成功',
  'auto.pages.pages.requirements.role-analysis.index.15': '保存失败',
  'auto.pages.pages.requirements.role-analysis.index.16':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.role-analysis.index.17': '已清空角色数据',
  'auto.pages.pages.requirements.role-analysis.index.18': '清空失败',
  'auto.pages.pages.requirements.role-analysis.index.19': '未填写',
  'auto.pages.pages.requirements.role-analysis.index.20': '角色',
  'auto.pages.pages.requirements.role-analysis.index.21': '未填写',
  'auto.pages.pages.requirements.role-analysis.index.22': '职责',
  'auto.pages.pages.requirements.role-analysis.index.23': '核心诉求',
  'auto.pages.pages.requirements.role-analysis.index.24': '关注功能范围',
  'auto.pages.pages.requirements.role-analysis.index.25': '产出交付物',
  'auto.pages.pages.requirements.role-analysis.index.26': '人名',
  'auto.pages.pages.requirements.role-analysis.index.27': '汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.28': '操作',
  'auto.pages.pages.requirements.role-analysis.index.29': '编辑',
  'auto.pages.pages.requirements.role-analysis.index.30': '确认删除该角色吗？',
  'auto.pages.pages.requirements.role-analysis.index.31': '确认',
  'auto.pages.pages.requirements.role-analysis.index.32': '取消',
  'auto.pages.pages.requirements.role-analysis.index.33': '删除',
  'auto.pages.pages.requirements.role-analysis.index.34': '清空重置',
  'auto.pages.pages.requirements.role-analysis.index.35': '角色',
  'auto.pages.pages.requirements.role-analysis.index.36': '未填写',
  'auto.pages.pages.requirements.role-analysis.index.37': '职责',
  'auto.pages.pages.requirements.role-analysis.index.38': '核心诉求',
  'auto.pages.pages.requirements.role-analysis.index.39': '关注功能范围',
  'auto.pages.pages.requirements.role-analysis.index.40': '产出交付物',
  'auto.pages.pages.requirements.role-analysis.index.41': '角色分析',
  'auto.pages.pages.requirements.role-analysis.index.42': '项目：{p1}',
  'auto.pages.pages.requirements.role-analysis.index.43': '关键字',
  'auto.pages.pages.requirements.role-analysis.index.44':
    '角色/职责/诉求/功能/交付物',
  'auto.pages.pages.requirements.role-analysis.index.45': '角色名称',
  'auto.pages.pages.requirements.role-analysis.index.46': '请输入角色名称',
  'auto.pages.pages.requirements.role-analysis.index.47': '对应人名',
  'auto.pages.pages.requirements.role-analysis.index.48': '请输入对应人名',
  'auto.pages.pages.requirements.role-analysis.index.49': '汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.50': '请输入汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.51': '职责关键字',
  'auto.pages.pages.requirements.role-analysis.index.52': '请输入职责关键字',
  'auto.pages.pages.requirements.role-analysis.index.53': '重置',
  'auto.pages.pages.requirements.role-analysis.index.54': '查询',
  'auto.pages.pages.requirements.role-analysis.index.55': '折叠',
  'auto.pages.pages.requirements.role-analysis.index.56': '展开',
  'auto.pages.pages.requirements.role-analysis.index.57': '已指派({p1})',
  'auto.pages.pages.requirements.role-analysis.index.58': '未指派({p1})',
  'auto.pages.pages.requirements.role-analysis.index.59': '全部({p1})',
  'auto.pages.pages.requirements.role-analysis.index.60': '刷新',
  'auto.pages.pages.requirements.role-analysis.index.61': '新增',
  'auto.pages.pages.requirements.role-analysis.index.62':
    '确认删除选中的 {p1} 条数据吗？',
  'auto.pages.pages.requirements.role-analysis.index.63': '确认',
  'auto.pages.pages.requirements.role-analysis.index.64': '取消',
  'auto.pages.pages.requirements.role-analysis.index.65': '批量删除（',
  'auto.pages.pages.requirements.role-analysis.index.66': 'AI角色分析',
  'auto.pages.pages.requirements.role-analysis.index.67': '保存',
  'auto.pages.pages.requirements.role-analysis.index.68':
    '确认清空当前项目角色数据？',
  'auto.pages.pages.requirements.role-analysis.index.69': '确认',
  'auto.pages.pages.requirements.role-analysis.index.70': '取消',
  'auto.pages.pages.requirements.role-analysis.index.71': '更多',
  'auto.pages.pages.requirements.role-analysis.index.72':
    '暂无角色分析数据，点击“新增”或“AI角色分析”开始',
  'auto.pages.pages.requirements.role-analysis.index.73': '表格显示：',
  'auto.pages.pages.requirements.role-analysis.index.74': '宽松',
  'auto.pages.pages.requirements.role-analysis.index.75': '默认',
  'auto.pages.pages.requirements.role-analysis.index.76': '紧凑',
  'auto.pages.pages.requirements.role-analysis.index.77': '列设置',
  'auto.pages.pages.requirements.role-analysis.index.78': '共 {p1} 条',
  'auto.pages.pages.requirements.role-analysis.index.79': '编辑角色',
  'auto.pages.pages.requirements.role-analysis.index.80': '新增角色',
  'auto.pages.pages.requirements.role-analysis.index.81': '确定',
  'auto.pages.pages.requirements.role-analysis.index.82': '取消',
  'auto.pages.pages.requirements.role-analysis.index.83': '角色名称',
  'auto.pages.pages.requirements.role-analysis.index.84': '请输入角色名称',
  'auto.pages.pages.requirements.role-analysis.index.85':
    '例如：产品经理、测试工程师',
  'auto.pages.pages.requirements.role-analysis.index.86': '职责',
  'auto.pages.pages.requirements.role-analysis.index.87': '请输入职责描述',
  'auto.pages.pages.requirements.role-analysis.index.88': '核心诉求',
  'auto.pages.pages.requirements.role-analysis.index.89': '关注功能范围',
  'auto.pages.pages.requirements.role-analysis.index.90': '产出交付物',
  'auto.pages.pages.requirements.role-analysis.index.91': '对应人名',
  'auto.pages.pages.requirements.role-analysis.index.92': '例如：张三',
  'auto.pages.pages.requirements.role-analysis.index.93': '汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.94': '例如：项目总监',
  'auto.pages.pages.requirements.role-analysis.index.95': 'AI 角色分析',
  'auto.pages.pages.requirements.role-analysis.index.96': '生成选项',
  'auto.pages.pages.requirements.role-analysis.index.97': '项目名称',
  'auto.pages.pages.requirements.role-analysis.index.98': '请输入项目名称',
  'auto.pages.pages.requirements.role-analysis.index.99': '请输入项目名称',
  'auto.pages.pages.requirements.role-analysis.index.100': '项目简介',
  'auto.pages.pages.requirements.role-analysis.index.101': '请输入项目简介',
  'auto.pages.pages.requirements.role-analysis.index.102':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.requirements.role-analysis.index.103':
    '例如：重点补充权限模型、外部系统依赖与验收标准',
  'auto.pages.pages.requirements.role-analysis.index.104': '拆解角色数量',
  'auto.pages.pages.requirements.role-analysis.index.105': '请输入拆解数量',
  'auto.pages.pages.requirements.role-analysis.index.106': '数量范围为 1-20',
  'auto.pages.pages.requirements.role-analysis.index.107':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.requirements.role-analysis.index.108': '保存项目信息',
  'auto.pages.pages.requirements.role-analysis.index.109': '取消',
  'auto.pages.pages.requirements.role-analysis.index.110': '生成预览',
  'auto.pages.pages.requirements.role-analysis.index.111': '预览结果',
  'auto.pages.pages.requirements.role-analysis.index.112':
    '勾选需要的角色后添加到列表',
  'auto.pages.pages.requirements.role-analysis.index.113':
    '点击“生成预览”后查看候选角色',
  'auto.pages.pages.requirements.role-analysis.index.114': '重名时覆盖已有角色',
  'auto.pages.pages.requirements.role-analysis.index.115':
    '添加选中到角色列表（',
  'auto.pages.pages.requirements.system-integration.index.1': '第三方系统',
  'auto.pages.pages.requirements.system-integration.index.2': '硬件设备',
  'auto.pages.pages.requirements.system-integration.index.3': '云服务',
  'auto.pages.pages.requirements.system-integration.index.4': '政务平台',
  'auto.pages.pages.requirements.system-integration.index.5': '支付平台',
  'auto.pages.pages.requirements.system-integration.index.6': '物流平台',
  'auto.pages.pages.requirements.system-integration.index.7': '其他',
  'auto.pages.pages.requirements.system-integration.index.8': '未命名项目',
  'auto.pages.pages.requirements.system-integration.index.9':
    '加载系统对接分析失败',
  'auto.pages.pages.requirements.system-integration.index.10':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.system-integration.index.11': '项目信息已保存',
  'auto.pages.pages.requirements.system-integration.index.12':
    '保存项目信息失败',
  'auto.pages.pages.requirements.system-integration.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.system-integration.index.14':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.requirements.system-integration.index.15': 'AI 生成失败',
  'auto.pages.pages.requirements.system-integration.index.16':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.system-integration.index.17':
    '请先勾选预览对接项',
  'auto.pages.pages.requirements.system-integration.index.18':
    '已添加并保存 {p1} 个对接项',
  'auto.pages.pages.requirements.system-integration.index.19': '添加失败',
  'auto.pages.pages.requirements.system-integration.index.20':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.system-integration.index.21': '保存成功',
  'auto.pages.pages.requirements.system-integration.index.22': '保存失败',
  'auto.pages.pages.requirements.system-integration.index.23':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.requirements.system-integration.index.24':
    '已清空系统对接分析数据',
  'auto.pages.pages.requirements.system-integration.index.25': '清空失败',
  'auto.pages.pages.requirements.system-integration.index.26': '未填写',
  'auto.pages.pages.requirements.system-integration.index.27': '系统/设备名称',
  'auto.pages.pages.requirements.system-integration.index.28': '未填写',
  'auto.pages.pages.requirements.system-integration.index.29': '类别',
  'auto.pages.pages.requirements.system-integration.index.30': '未填写',
  'auto.pages.pages.requirements.system-integration.index.31': '对接方式',
  'auto.pages.pages.requirements.system-integration.index.32': '协议类型',
  'auto.pages.pages.requirements.system-integration.index.33': '接口/连接地址',
  'auto.pages.pages.requirements.system-integration.index.34': '认证方式',
  'auto.pages.pages.requirements.system-integration.index.35': '数据方向',
  'auto.pages.pages.requirements.system-integration.index.36': '难度',
  'auto.pages.pages.requirements.system-integration.index.37': '工作量(人天)',
  'auto.pages.pages.requirements.system-integration.index.38': '接口状态',
  'auto.pages.pages.requirements.system-integration.index.39': '是否收费',
  'auto.pages.pages.requirements.system-integration.index.40': '是',
  'auto.pages.pages.requirements.system-integration.index.41': '否',
  'auto.pages.pages.requirements.system-integration.index.42': '费用情况',
  'auto.pages.pages.requirements.system-integration.index.43': '供应商',
  'auto.pages.pages.requirements.system-integration.index.44': '对接人',
  'auto.pages.pages.requirements.system-integration.index.45': '对接电话',
  'auto.pages.pages.requirements.system-integration.index.46': '对接邮箱',
  'auto.pages.pages.requirements.system-integration.index.47': '风险与限制',
  'auto.pages.pages.requirements.system-integration.index.48': '备注',
  'auto.pages.pages.requirements.system-integration.index.49': '状态',
  'auto.pages.pages.requirements.system-integration.index.50': '操作',
  'auto.pages.pages.requirements.system-integration.index.51': '编辑',
  'auto.pages.pages.requirements.system-integration.index.52': '删除',
  'auto.pages.pages.requirements.system-integration.index.53': '系统/设备名称',
  'auto.pages.pages.requirements.system-integration.index.54': '未填写',
  'auto.pages.pages.requirements.system-integration.index.55': '类别',
  'auto.pages.pages.requirements.system-integration.index.56': '对接方式',
  'auto.pages.pages.requirements.system-integration.index.57': '协议类型',
  'auto.pages.pages.requirements.system-integration.index.58': '难度',
  'auto.pages.pages.requirements.system-integration.index.59': '工作量',
  'auto.pages.pages.requirements.system-integration.index.60': '接口状态',
  'auto.pages.pages.requirements.system-integration.index.61': '收费',
  'auto.pages.pages.requirements.system-integration.index.62': '是',
  'auto.pages.pages.requirements.system-integration.index.63': '否',
  'auto.pages.pages.requirements.system-integration.index.64': '系统对接',
  'auto.pages.pages.requirements.system-integration.index.65':
    '基于项目“{p1}”识别第三方系统与硬件设备对接需求',
  'auto.pages.pages.requirements.system-integration.index.66': 'AI系统对接分析',
  'auto.pages.pages.requirements.system-integration.index.67': '新增对接项',
  'auto.pages.pages.requirements.system-integration.index.68': '保存',
  'auto.pages.pages.requirements.system-integration.index.69':
    '确认清空当前项目系统对接数据？',
  'auto.pages.pages.requirements.system-integration.index.70': '清空重置',
  'auto.pages.pages.requirements.system-integration.index.71': '删除选中（',
  'auto.pages.pages.requirements.system-integration.index.72':
    '暂无系统对接数据，点击“AI系统对接分析”或“新增对接项”开始',
  'auto.pages.pages.requirements.system-integration.index.73': '编辑系统对接项',
  'auto.pages.pages.requirements.system-integration.index.74': '新增系统对接项',
  'auto.pages.pages.requirements.system-integration.index.75': '确定',
  'auto.pages.pages.requirements.system-integration.index.76': '取消',
  'auto.pages.pages.requirements.system-integration.index.77': '系统/设备名称',
  'auto.pages.pages.requirements.system-integration.index.78':
    '请输入系统或设备名称',
  'auto.pages.pages.requirements.system-integration.index.79':
    '例如：SAP ERP、金税平台、条码扫描设备',
  'auto.pages.pages.requirements.system-integration.index.80': '类别',
  'auto.pages.pages.requirements.system-integration.index.81': '对接方式',
  'auto.pages.pages.requirements.system-integration.index.82':
    '协议类型（输入框）',
  'auto.pages.pages.requirements.system-integration.index.83':
    '例如：HTTPS+JSON、AMQP、MQTT、Modbus TCP',
  'auto.pages.pages.requirements.system-integration.index.84': '认证方式',
  'auto.pages.pages.requirements.system-integration.index.85':
    '例如：OAuth2、AK/SK、BasicAuth、设备证书',
  'auto.pages.pages.requirements.system-integration.index.86': '接口/连接地址',
  'auto.pages.pages.requirements.system-integration.index.87':
    '例如：https://api.partner.com/v1/orders 或 mq://cluster/topic',
  'auto.pages.pages.requirements.system-integration.index.88': '数据方向',
  'auto.pages.pages.requirements.system-integration.index.89': '对接难度',
  'auto.pages.pages.requirements.system-integration.index.90':
    '工作量预估（人天）',
  'auto.pages.pages.requirements.system-integration.index.91': '第三方接口状态',
  'auto.pages.pages.requirements.system-integration.index.92': '是否收费',
  'auto.pages.pages.requirements.system-integration.index.93':
    '该对接项需要收费',
  'auto.pages.pages.requirements.system-integration.index.94': '状态',
  'auto.pages.pages.requirements.system-integration.index.95': '费用情况',
  'auto.pages.pages.requirements.system-integration.index.96':
    '例如：按调用量计费、按年授权、一次性设备采购等',
  'auto.pages.pages.requirements.system-integration.index.97':
    '供应商/对接方名称',
  'auto.pages.pages.requirements.system-integration.index.98': '对接人',
  'auto.pages.pages.requirements.system-integration.index.99': '对接人电话',
  'auto.pages.pages.requirements.system-integration.index.100': '对接人邮箱',
  'auto.pages.pages.requirements.system-integration.index.101': '风险与限制',
  'auto.pages.pages.requirements.system-integration.index.102': '备注',
  'auto.pages.pages.requirements.system-integration.index.103':
    'AI 系统对接分析',
  'auto.pages.pages.requirements.system-integration.index.104': '生成选项',
  'auto.pages.pages.requirements.system-integration.index.105': '项目名称',
  'auto.pages.pages.requirements.system-integration.index.106':
    '请输入项目名称',
  'auto.pages.pages.requirements.system-integration.index.107':
    '请输入项目名称',
  'auto.pages.pages.requirements.system-integration.index.108': '项目简介',
  'auto.pages.pages.requirements.system-integration.index.109':
    '请输入项目简介',
  'auto.pages.pages.requirements.system-integration.index.110':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.requirements.system-integration.index.111':
    '例如：重点识别财务平台、物流平台、工业设备、消息中间件等外部依赖',
  'auto.pages.pages.requirements.system-integration.index.112':
    '拆解对接项数量',
  'auto.pages.pages.requirements.system-integration.index.113':
    '请输入拆解数量',
  'auto.pages.pages.requirements.system-integration.index.114':
    '数量范围为 1-30',
  'auto.pages.pages.requirements.system-integration.index.115':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.requirements.system-integration.index.116': '保存项目信息',
  'auto.pages.pages.requirements.system-integration.index.117': '取消',
  'auto.pages.pages.requirements.system-integration.index.118': '生成预览',
  'auto.pages.pages.requirements.system-integration.index.119': '预览结果',
  'auto.pages.pages.requirements.system-integration.index.120':
    '勾选需要的对接项后添加到列表',
  'auto.pages.pages.requirements.system-integration.index.121':
    '点击“生成预览”后查看候选对接项',
  'auto.pages.pages.requirements.system-integration.index.122':
    '重名时覆盖已有对接项',
  'auto.pages.pages.requirements.system-integration.index.123':
    '添加选中到对接列表（',
  'auto.pages.pages.task-management.index.1': '完成支付模块接口联调',
  'auto.pages.pages.task-management.index.2': '张三',
  'auto.pages.pages.task-management.index.3': '补充用户中心单元测试',
  'auto.pages.pages.task-management.index.4': '李四',
  'auto.pages.pages.task-management.index.5': '发布前回归清单确认',
  'auto.pages.pages.task-management.index.6': '王五',
  'auto.pages.pages.task-management.index.7': '任务',
  'auto.pages.pages.task-management.index.8': '负责人',
  'auto.pages.pages.task-management.index.9': '迭代',
  'auto.pages.pages.task-management.index.10': '优先级',
  'auto.pages.pages.task-management.index.11': '高',
  'auto.pages.pages.task-management.index.12': '中',
  'auto.pages.pages.task-management.index.13': '低',
  'auto.pages.pages.task-management.index.14': '状态',
  'auto.pages.pages.task-management.index.15': '待处理',
  'auto.pages.pages.task-management.index.16': '进行中',
  'auto.pages.pages.task-management.index.17': '已完成',
  'auto.pages.pages.task-management.index.18': '任务管理',
  'auto.pages.pages.task-management.index.19': '任务拆解、分派、跟踪与迭代推进',
  'auto.pages.pages.test-management.bug.index.1': '缺陷标题',
  'auto.pages.pages.test-management.bug.index.2': '严重程度',
  'auto.pages.pages.test-management.bug.index.3': '阻断',
  'auto.pages.pages.test-management.bug.index.4': '严重',
  'auto.pages.pages.test-management.bug.index.5': '主要',
  'auto.pages.pages.test-management.bug.index.6': '次要',
  'auto.pages.pages.test-management.bug.index.7': '优先级',
  'auto.pages.pages.test-management.bug.index.8': '状态',
  'auto.pages.pages.test-management.bug.index.9': '新建',
  'auto.pages.pages.test-management.bug.index.10': '处理中',
  'auto.pages.pages.test-management.bug.index.11': '已解决',
  'auto.pages.pages.test-management.bug.index.12': '已修复',
  'auto.pages.pages.test-management.bug.index.13': '已关闭',
  'auto.pages.pages.test-management.bug.index.14': '创建人',
  'auto.pages.pages.test-management.bug.index.15': '处理人',
  'auto.pages.pages.test-management.bug.index.16': '创建时间',
  'auto.pages.pages.test-management.bug.index.17': '操作',
  'auto.pages.pages.test-management.bug.index.18': '编辑',
  'auto.pages.pages.test-management.bug.index.19': '详情',
  'auto.pages.pages.test-management.bug.index.20': '新建缺陷',
  'auto.pages.pages.test-management.case.index.1': '用例名称',
  'auto.pages.pages.test-management.case.index.2': '用例级别',
  'auto.pages.pages.test-management.case.index.3': '测试类型',
  'auto.pages.pages.test-management.case.index.4': '功能测试',
  'auto.pages.pages.test-management.case.index.5': '性能测试',
  'auto.pages.pages.test-management.case.index.6': '接口测试',
  'auto.pages.pages.test-management.case.index.7': '安全测试',
  'auto.pages.pages.test-management.case.index.8': '状态',
  'auto.pages.pages.test-management.case.index.9': '草稿',
  'auto.pages.pages.test-management.case.index.10': '评审中',
  'auto.pages.pages.test-management.case.index.11': '待执行',
  'auto.pages.pages.test-management.case.index.12': '创建人',
  'auto.pages.pages.test-management.case.index.13': '更新时间',
  'auto.pages.pages.test-management.case.index.14': '操作',
  'auto.pages.pages.test-management.case.index.15': 'Mock: 编辑功能',
  'auto.pages.pages.test-management.case.index.16': '编辑',
  'auto.pages.pages.test-management.case.index.17': 'Mock: 执行用例',
  'auto.pages.pages.test-management.case.index.18': '执行',
  'auto.pages.pages.test-management.case.index.19': '确认删除？',
  'auto.pages.pages.test-management.case.index.20': '已删除（Mock）',
  'auto.pages.pages.test-management.case.index.21': '删除',
  'auto.pages.pages.test-management.case.index.22': 'Mock: 新建用例',
  'auto.pages.pages.test-management.case.index.23': '新建用例',
  'auto.pages.pages.test-management.case-library.index.1': '库名称',
  'auto.pages.pages.test-management.case-library.index.2': '描述',
  'auto.pages.pages.test-management.case-library.index.3': '用例总数',
  'auto.pages.pages.test-management.case-library.index.4': '个',
  'auto.pages.pages.test-management.case-library.index.5': '创建人',
  'auto.pages.pages.test-management.case-library.index.6': '更新时间',
  'auto.pages.pages.test-management.case-library.index.7': '操作',
  'auto.pages.pages.test-management.case-library.index.8': 'Mock: 编辑用例库',
  'auto.pages.pages.test-management.case-library.index.9': '编辑',
  'auto.pages.pages.test-management.case-library.index.10': 'Mock: 管理用例库',
  'auto.pages.pages.test-management.case-library.index.11': '管理',
  'auto.pages.pages.test-management.case-library.index.12': '确认删除用例库？',
  'auto.pages.pages.test-management.case-library.index.13': '已删除（Mock）',
  'auto.pages.pages.test-management.case-library.index.14': '删除',
  'auto.pages.pages.test-management.case-library.index.15': 'Mock: 新建用例库',
  'auto.pages.pages.test-management.case-library.index.16': '新建用例库',
  'auto.pages.pages.test-management.dashboard.index.1': '用例分布',
  'auto.pages.pages.test-management.dashboard.index.2': '严重程度',
  'auto.pages.pages.test-management.dashboard.index.3': '缺陷数量',
  'auto.pages.pages.test-management.dashboard.index.4': '测试名称',
  'auto.pages.pages.test-management.dashboard.index.5': '负责人',
  'auto.pages.pages.test-management.dashboard.index.6': '状态',
  'auto.pages.pages.test-management.dashboard.index.7': '已完成',
  'auto.pages.pages.test-management.dashboard.index.8': '进行中',
  'auto.pages.pages.test-management.dashboard.index.9': '失败',
  'auto.pages.pages.test-management.dashboard.index.10': '排队中',
  'auto.pages.pages.test-management.dashboard.index.11': '进度',
  'auto.pages.pages.test-management.dashboard.index.12': '开始时间',
  'auto.pages.pages.test-management.dashboard.index.13': '测试管理仪表盘',
  'auto.pages.pages.test-management.dashboard.index.14': '用例状态分布',
  'auto.pages.pages.test-management.dashboard.index.15': '缺陷严重程度分布',
  'auto.pages.pages.test-management.dashboard.index.16': '用例执行趋势',
  'auto.pages.pages.test-management.dashboard.index.17': '缺陷发现与修复趋势',
  'auto.pages.pages.test-management.dashboard.index.18': '近期测试任务',
  'auto.pages.pages.test-management.index.1': '项目切换后菜单状态保持',
  'auto.pages.pages.test-management.index.2': '需求概要AI生成结果可保存',
  'auto.pages.pages.test-management.index.3': '代码仓库授权失败回滚',
  'auto.pages.pages.test-management.order.index.1': '测试单标题',
  'auto.pages.pages.test-management.order.index.2': '测试类型',
  'auto.pages.pages.test-management.order.index.3': '全功能测试',
  'auto.pages.pages.test-management.order.index.4': '冒烟测试',
  'auto.pages.pages.test-management.order.index.5': '专项测试',
  'auto.pages.pages.test-management.order.index.6': '性能测试',
  'auto.pages.pages.test-management.order.index.7': '当前进度',
  'auto.pages.pages.test-management.order.index.8': '状态',
  'auto.pages.pages.test-management.order.index.9': '草稿',
  'auto.pages.pages.test-management.order.index.10': '执行中',
  'auto.pages.pages.test-management.order.index.11': '已完成',
  'auto.pages.pages.test-management.order.index.12': '已终止',
  'auto.pages.pages.test-management.order.index.13': '负责人',
  'auto.pages.pages.test-management.order.index.14': '计划完成日期',
  'auto.pages.pages.test-management.order.index.15': '操作',
  'auto.pages.pages.test-management.order.index.16': 'Mock: 编辑测试单',
  'auto.pages.pages.test-management.order.index.17': '编辑',
  'auto.pages.pages.test-management.order.index.18': 'Mock: 进入执行空间',
  'auto.pages.pages.test-management.order.index.19': '执行',
  'auto.pages.pages.test-management.order.index.20': 'Mock: 查看报告',
  'auto.pages.pages.test-management.order.index.21': '报告',
  'auto.pages.pages.test-management.order.index.22': 'Mock: 新建测试单',
  'auto.pages.pages.test-management.order.index.23': '新建测试单',
  'auto.pages.pages.test-management.report.index.1': '报告名称',
  'auto.pages.pages.test-management.report.index.2': '关联测试单',
  'auto.pages.pages.test-management.report.index.3': '通过率',
  'auto.pages.pages.test-management.report.index.4': '缺陷数',
  'auto.pages.pages.test-management.report.index.5': '负责人',
  'auto.pages.pages.test-management.report.index.6': '生成时间',
  'auto.pages.pages.test-management.report.index.7': '操作',
  'auto.pages.pages.test-management.report.index.8': 'Mock: 查看报告详情',
  'auto.pages.pages.test-management.report.index.9': '查看',
  'auto.pages.pages.test-management.report.index.10': 'Mock: 下载 PDF',
  'auto.pages.pages.test-management.report.index.11': '下载',
  'auto.pages.pages.test-management.report.index.12': '确认删除报告？',
  'auto.pages.pages.test-management.report.index.13': '报告已删除（Mock）',
  'auto.pages.pages.test-management.report.index.14': '删除',
  'auto.pages.pages.test-management.suite.index.1': '测试集名称',
  'auto.pages.pages.test-management.suite.index.2': '描述',
  'auto.pages.pages.test-management.suite.index.3': '包含用例数',
  'auto.pages.pages.test-management.suite.index.4': '个用例',
  'auto.pages.pages.test-management.suite.index.5': '创建人',
  'auto.pages.pages.test-management.suite.index.6': '创建时间',
  'auto.pages.pages.test-management.suite.index.7': '操作',
  'auto.pages.pages.test-management.suite.index.8': 'Mock: 编辑功能',
  'auto.pages.pages.test-management.suite.index.9': '编辑',
  'auto.pages.pages.test-management.suite.index.10': 'Mock: 管理用例',
  'auto.pages.pages.test-management.suite.index.11': '管理用例',
  'auto.pages.pages.test-management.suite.index.12': '确认删除？',
  'auto.pages.pages.test-management.suite.index.13': '已删除（Mock）',
  'auto.pages.pages.test-management.suite.index.14': '删除',
  'auto.pages.pages.test-management.suite.index.15': 'Mock: 新建测试集',
  'auto.pages.pages.test-management.suite.index.16': '新建测试集',
  'auto.component.components.Footer.index.1':
    '2026 珊瑚智成（北京）科技有限公司',
  'auto.component.components.Layout.SiderResizeHandle.1': '调整菜单宽度',
  'auto.component.components.LexicalBlockEditor.1': '请输入链接地址',
  'auto.component.components.LexicalBlockEditor.2': '撤销',
  'auto.component.components.LexicalBlockEditor.3': '重做',
  'auto.component.components.LexicalBlockEditor.4': '正文',
  'auto.component.components.LexicalBlockEditor.5': '标题 1',
  'auto.component.components.LexicalBlockEditor.6': '标题 2',
  'auto.component.components.LexicalBlockEditor.7': '标题 3',
  'auto.component.components.LexicalBlockEditor.8': '引用',
  'auto.component.components.LexicalBlockEditor.9': '代码块',
  'auto.component.components.LexicalBlockEditor.10': '无序列表',
  'auto.component.components.LexicalBlockEditor.11': '有序列表',
  'auto.component.components.LexicalBlockEditor.12': '任务列表',
  'auto.component.components.LexicalBlockEditor.13': '加粗',
  'auto.component.components.LexicalBlockEditor.14': '斜体',
  'auto.component.components.LexicalBlockEditor.15': '下划线',
  'auto.component.components.LexicalBlockEditor.16': '删除线',
  'auto.component.components.LexicalBlockEditor.17': '行内代码',
  'auto.component.components.LexicalBlockEditor.18': '取消链接',
  'auto.component.components.LexicalBlockEditor.19': '插入链接',
  'auto.component.components.LexicalBlockEditor.20': '无序列表',
  'auto.component.components.LexicalBlockEditor.21': '有序列表',
  'auto.component.components.LexicalBlockEditor.22': '插入表格',
  'auto.component.components.LexicalBlockEditor.23': '上方插入行',
  'auto.component.components.LexicalBlockEditor.24': '行↑',
  'auto.component.components.LexicalBlockEditor.25': '下方插入行',
  'auto.component.components.LexicalBlockEditor.26': '行↓',
  'auto.component.components.LexicalBlockEditor.27': '左侧插入列',
  'auto.component.components.LexicalBlockEditor.28': '列←',
  'auto.component.components.LexicalBlockEditor.29': '右侧插入列',
  'auto.component.components.LexicalBlockEditor.30': '列→',
  'auto.component.components.LexicalBlockEditor.31': '左对齐',
  'auto.component.components.LexicalBlockEditor.32': '居中',
  'auto.component.components.LexicalBlockEditor.33': '右对齐',
  'auto.component.components.LexicalBlockEditor.34': '请输入链接地址',
  'auto.component.components.LexicalBlockEditor.35': '加粗',
  'auto.component.components.LexicalBlockEditor.36': '斜体',
  'auto.component.components.LexicalBlockEditor.37': '下划线',
  'auto.component.components.LexicalBlockEditor.38': '删除线',
  'auto.component.components.LexicalBlockEditor.39': '下标',
  'auto.component.components.LexicalBlockEditor.40': '上标',
  'auto.component.components.LexicalBlockEditor.41': '行内代码',
  'auto.component.components.LexicalBlockEditor.42': '取消链接',
  'auto.component.components.LexicalBlockEditor.43': '插入链接',
  'auto.component.components.LexicalBlockEditor.44': '正文',
  'auto.component.components.LexicalBlockEditor.45': '段落',
  'auto.component.components.LexicalBlockEditor.46': '标题1',
  'auto.component.components.LexicalBlockEditor.47': '一级标题',
  'auto.component.components.LexicalBlockEditor.48': '标题2',
  'auto.component.components.LexicalBlockEditor.49': '二级标题',
  'auto.component.components.LexicalBlockEditor.50': '标题3',
  'auto.component.components.LexicalBlockEditor.51': '三级标题',
  'auto.component.components.LexicalBlockEditor.52': '有序',
  'auto.component.components.LexicalBlockEditor.53': '序号',
  'auto.component.components.LexicalBlockEditor.54': '无序',
  'auto.component.components.LexicalBlockEditor.55': '圆点',
  'auto.component.components.LexicalBlockEditor.56': '任务',
  'auto.component.components.LexicalBlockEditor.57': '清单',
  'auto.component.components.LexicalBlockEditor.58': '表格',
  'auto.component.components.LexicalBlockEditor.59': '分割线',
  'auto.component.components.LexicalBlockEditor.60': '引用',
  'auto.component.components.LexicalBlockEditor.61': '代码',
  'auto.component.components.LexicalBlockEditor.62': '代码块',
  'auto.component.components.LexicalBlockEditor.63': '拖动排序',
  'auto.component.components.LexicalBlockEditor.64': '放置到此处',
  'auto.component.components.LexicalBlockEditor.65': '请输入概要内容',
  'auto.component.components.RichTextEditor.index.1': '请输入内容...',
  'auto.pages.pages.requirements.concept-analysis.group.index.1': '当前项目',
  'auto.pages.pages.requirements.concept-analysis.group.index.2': '当前项目',
  'auto.pages.pages.requirements.concept-analysis.group.index.3':
    '加载概念分组失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.4':
    '请先选择项目',
  'auto.pages.pages.requirements.concept-analysis.group.index.5':
    '请输入分组名称（支持一行一个）',
  'auto.pages.pages.requirements.concept-analysis.group.index.6':
    '创建分组失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.7':
    '已创建 {{p1}} 个分组，失败 {{p2}} 个',
  'auto.pages.pages.requirements.concept-analysis.group.index.8':
    '已创建 {{p1}} 个分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.9':
    '创建分组失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.10':
    '创建分组失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.11': '分组已更新',
  'auto.pages.pages.requirements.concept-analysis.group.index.12':
    '更新分组失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.13': '分组已删除',
  'auto.pages.pages.requirements.concept-analysis.group.index.14':
    '删除分组失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.15':
    '请先选择分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.16':
    '分组成员已保存',
  'auto.pages.pages.requirements.concept-analysis.group.index.17':
    '保存分组成员失败',
  'auto.pages.pages.requirements.concept-analysis.group.index.18': '概念分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.19':
    '项目：{{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.20': '分组列表',
  'auto.pages.pages.requirements.concept-analysis.group.index.21': '新建分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.22': '暂无分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.23':
    '确认删除该分组？',
  'auto.pages.pages.requirements.concept-analysis.group.index.24': '删除',
  'auto.pages.pages.requirements.concept-analysis.group.index.25':
    '成员维护：{{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.26': '成员维护',
  'auto.pages.pages.requirements.concept-analysis.group.index.27': '保存成员',
  'auto.pages.pages.requirements.concept-analysis.group.index.28':
    '请选择左侧分组后编辑成员',
  'auto.pages.pages.requirements.concept-analysis.group.index.29':
    '一个概念可以属于多个分组。以下选择将覆盖当前分组成员。',
  'auto.pages.pages.requirements.concept-analysis.group.index.30':
    '搜索概念中文名',
  'auto.pages.pages.requirements.concept-analysis.group.index.31':
    '新建概念分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.32': '创建',
  'auto.pages.pages.requirements.concept-analysis.group.index.33':
    '分组名称，支持批量添加（一行一个）\n例如：\n核心业务概念\n业务流程概念',
  'auto.pages.pages.requirements.concept-analysis.group.index.34':
    '分组描述（可选，批量创建时会应用到每个分组）',
  'auto.pages.pages.requirements.concept-analysis.management.index.1':
    '请至少输入一条概念，支持“概念名｜释义”按行录入',
  'auto.pages.pages.requirements.concept-analysis.management.index.2':
    '已根据人工录入生成 {{p1}} 条概念预览',
  'auto.pages.pages.requirements.concept-analysis.management.index.3':
    '拆解模式：尽可能多（上限100）',
  'auto.pages.pages.requirements.concept-analysis.management.index.4':
    '拆解模式：指定数量（{{p1}}）',
  'auto.pages.pages.requirements.concept-analysis.management.index.5': '关联',
  'auto.pages.pages.requirements.concept-analysis.management.index.6': '层级',
  'auto.pages.pages.requirements.concept-analysis.management.index.7': '层级',
  'auto.pages.pages.requirements.concept-analysis.management.index.8': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.9': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.10':
    '其他别称',
  'auto.pages.pages.requirements.concept-analysis.management.index.11': '本质',
  'auto.pages.pages.requirements.concept-analysis.management.index.12':
    '应用场景',
  'auto.pages.pages.requirements.concept-analysis.management.index.13':
    '相关概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.14': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.15': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.16':
    '其他别称',
  'auto.pages.pages.requirements.concept-analysis.management.index.17': '本质',
  'auto.pages.pages.requirements.concept-analysis.management.index.18':
    '应用场景',
  'auto.pages.pages.requirements.concept-analysis.management.index.19':
    '相关概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.20':
    '确认删除概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.21':
    '确认删除',
  'auto.pages.pages.requirements.concept-analysis.management.index.22': '取消',
  'auto.pages.pages.requirements.concept-analysis.management.index.23':
    '删除概念会同步移除与其相关的关系。当前将删除',
  'auto.pages.pages.requirements.concept-analysis.management.index.24':
    '个概念，预计影响',
  'auto.pages.pages.requirements.concept-analysis.management.index.25':
    '条关系。',
  'auto.pages.pages.requirements.concept-analysis.management.index.26':
    '涉及概念：',
  'auto.pages.pages.requirements.concept-analysis.management.index.27':
    ' 等 {{p1}} 个',
  'auto.pages.pages.requirements.concept-analysis.management.index.28': '还有',
  'auto.pages.pages.requirements.concept-analysis.management.index.29':
    '条关系未展示',
  'auto.pages.pages.requirements.concept-analysis.management.index.30':
    '未检测到关系影响。',
  'auto.pages.pages.requirements.concept-analysis.management.index.31':
    '其他别称（多个）',
  'auto.pages.pages.requirements.concept-analysis.management.index.32':
    '输入后回车，可添加多个',
  'auto.pages.pages.requirements.concept-analysis.management.index.33':
    '请选择上位概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.34':
    '请选择下位概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.35':
    '是否核心概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.36':
    '核心概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.37': '草稿',
  'auto.pages.pages.requirements.concept-analysis.management.index.38':
    '进行中',
  'auto.pages.pages.requirements.concept-analysis.management.index.39':
    '已归档',
  'auto.pages.pages.requirements.concept-analysis.management.index.40':
    '相关概念（可选择或新建）',
  'auto.pages.pages.requirements.concept-analysis.management.index.41':
    '可直接输入新概念名称',
  'auto.pages.pages.requirements.concept-analysis.management.index.42': '本质',
  'auto.pages.pages.requirements.concept-analysis.management.index.43':
    '应用场景',
  'auto.pages.pages.requirements.concept-analysis.management.index.44':
    '支持粘贴 Markdown 概念表；系统会优先按资料抽取概念，指定数量仅作为参考。',
  'auto.pages.pages.requirements.concept-analysis.management.index.45':
    '已检测到 Markdown 表格，将优先按资料抽取概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.46':
    '拆解模式',
  'auto.pages.pages.requirements.concept-analysis.management.index.47':
    'A、尽可能多',
  'auto.pages.pages.requirements.concept-analysis.management.index.48':
    'B、指定数量',
  'auto.pages.pages.requirements.concept-analysis.management.index.49':
    'C、人工录入',
  'auto.pages.pages.requirements.concept-analysis.management.index.50':
    '请输入 1-100 的整数',
  'auto.pages.pages.requirements.concept-analysis.management.index.51':
    '人工录入',
  'auto.pages.pages.requirements.concept-analysis.management.index.52':
    '请输入人工概念清单',
  'auto.pages.pages.requirements.concept-analysis.management.index.53':
    '每行一条，支持“概念名｜释义”格式；只填概念名也可。',
  'auto.pages.pages.requirements.concept-analysis.management.index.54':
    '例如：\n需求条目｜可被跟踪和验收的最小需求单元\n功能清单｜系统能力的结构化列表',
  'auto.pages.pages.requirements.concept-analysis.relation.index.1': '当前项目',
  'auto.pages.pages.requirements.concept-analysis.relation.index.2': '当前项目',
  'auto.pages.pages.requirements.concept-analysis.relation.index.3':
    '加载概念关系失败',
  'auto.pages.pages.requirements.concept-analysis.relation.index.4': '关联',
  'auto.pages.pages.requirements.concept-analysis.relation.index.5': '层级',
  'auto.pages.pages.requirements.concept-analysis.relation.index.6': '核心概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.7': '普通概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.8': '核心概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.9': '普通概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.10':
    '来源概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.11':
    '请选择来源概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.12':
    '目标概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.13':
    '请选择目标概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.14':
    '关系类型',
  'auto.pages.pages.requirements.concept-analysis.relation.index.15': '关联',
  'auto.pages.pages.requirements.concept-analysis.relation.index.16': '层级',
  'auto.pages.pages.requirements.concept-analysis.relation.index.17': '操作',
  'auto.pages.pages.requirements.concept-analysis.relation.index.18': '删除',
  'auto.pages.pages.requirements.concept-analysis.relation.index.19':
    '请先选择项目',
  'auto.pages.pages.requirements.concept-analysis.relation.index.20':
    '第 {p1} 行关系缺少合法概念，请检查后重试',
  'auto.pages.pages.requirements.concept-analysis.relation.index.21':
    '第 {p1} 行存在自环关系（来源=目标），请修正',
  'auto.pages.pages.requirements.concept-analysis.relation.index.22':
    '层级冲突：概念“{p1}”同时存在多个父概念（{p2} / {p3}）',
  'auto.pages.pages.requirements.concept-analysis.relation.index.23':
    '关系保存成功',
  'auto.pages.pages.requirements.concept-analysis.relation.index.24':
    '关系保存失败',
  'auto.pages.pages.requirements.concept-analysis.relation.index.25':
    '概念关系',
  'auto.pages.pages.requirements.concept-analysis.relation.index.26':
    '项目：{p1}',
  'auto.pages.pages.requirements.concept-analysis.relation.index.27': '关系图',
  'auto.pages.pages.requirements.concept-analysis.relation.index.28':
    '关联关系：',
  'auto.pages.pages.requirements.concept-analysis.relation.index.29':
    '层级关系：',
  'auto.pages.pages.requirements.concept-analysis.relation.index.30':
    '概念节点：',
  'auto.pages.pages.requirements.concept-analysis.relation.index.31':
    '图谱展示“相关概念 +\n                    上下位概念”关系，支持拖拽、缩放和悬浮查看。',
  'auto.pages.pages.requirements.concept-analysis.relation.index.32':
    '暂无概念数据',
  'auto.pages.pages.requirements.concept-analysis.relation.index.33':
    '表格管理',
  'auto.pages.pages.requirements.concept-analysis.relation.index.34':
    '新增关系',
  'auto.pages.pages.requirements.concept-analysis.relation.index.35':
    '删除选中（',
  'auto.pages.pages.requirements.concept-analysis.relation.index.36':
    '保存关系',
  'auto.pages.pages.project.agent-management.index.1': '加载本项目Agent失败',
  'auto.pages.pages.project.agent-management.index.2': '加载可绑定Agent失败',
  'auto.pages.pages.project.agent-management.index.3': 'Agent 更新成功',
  'auto.pages.pages.project.agent-management.index.4': 'Agent 创建并绑定成功',
  'auto.pages.pages.project.agent-management.index.5': '绑定成功',
  'auto.pages.pages.project.agent-management.index.6': '绑定失败',
  'auto.pages.pages.project.agent-management.index.7': '已从当前项目解绑',
  'auto.pages.pages.project.agent-management.index.8': '解绑失败',
  'auto.pages.pages.project.agent-management.index.9': '加载Secret信息失败',
  'auto.pages.pages.project.agent-management.index.10': 'Secrets 已更新',
  'auto.pages.pages.project.agent-management.index.11': '名称',
  'auto.pages.pages.project.agent-management.index.12': '状态',
  'auto.pages.pages.project.agent-management.index.13': '操作',
  'auto.pages.pages.project.agent-management.index.14': '编辑',
  'auto.pages.pages.project.agent-management.index.15':
    '确认从当前项目解绑该 Agent 吗？',
  'auto.pages.pages.project.agent-management.index.16': '解绑',
  'auto.pages.pages.project.agent-management.index.17': '名称',
  'auto.pages.pages.project.agent-management.index.18': '状态',
  'auto.pages.pages.project.agent-management.index.19': '操作',
  'auto.pages.pages.project.agent-management.index.20': '绑定到本项目',
  'auto.pages.pages.project.agent-management.index.21': 'Agent管理',
  'auto.pages.pages.project.agent-management.index.22':
    '项目上下文下管理Agent绑定与Secrets',
  'auto.pages.pages.project.agent-management.index.23': '搜索名称 / URL / Host',
  'auto.pages.pages.project.agent-management.index.24': '状态',
  'auto.pages.pages.project.agent-management.index.25': '刷新',
  'auto.pages.pages.project.agent-management.index.26': '绑定现有Agent',
  'auto.pages.pages.project.agent-management.index.27': '快速新建Agent',
  'auto.pages.pages.project.agent-management.index.28': '绑定现有Agent',
  'auto.pages.pages.project.agent-management.index.29': '搜索名称 / URL / Host',
  'auto.pages.pages.project.agent-management.index.30': '状态',
  'auto.pages.pages.project.agent-management.index.31': '刷新',
  'auto.pages.pages.project.agent-management.index.32': '编辑Agent',
  'auto.pages.pages.project.agent-management.index.33': '快速新建Agent',
  'auto.pages.pages.project.agent-management.index.34': '名称',
  'auto.pages.pages.project.agent-management.index.35': '请输入Agent名称',
  'auto.pages.pages.project.agent-management.index.36': '请选择Provider',
  'auto.pages.pages.project.agent-management.index.37': '请输入Base URL',
  'auto.pages.pages.project.agent-management.index.38': '状态',
  'auto.pages.pages.project.agent-management.index.39': '描述',
  'auto.pages.pages.project.agent-management.index.40': '配置Secrets{{p1}}',
  'auto.pages.pages.project.agent-management.index.41':
    '当前Secret Keys（仅显示key，不回显明文）',
  'auto.pages.pages.project.agent-management.index.42': '请输入Key',
  'auto.pages.pages.project.agent-management.index.43': '例如 OPENAI_API_KEY',
  'auto.pages.pages.project.agent-management.index.44': '请输入Value',
  'auto.pages.pages.project.agent-management.index.45':
    '请输入明文Value（保存后不回显）',
  'auto.pages.pages.project.agent-management.index.46': '删除',
  'auto.pages.pages.project.agent-management.index.47': '添加一条Secret',
};
